<template>
  <div class="pb_content" style="overflow: unset">
    <div class="pb_content_body" style="display: flex; height: 900px; position: relative">
      <div class="pb_left">
        <!-- <div class="courseTitle">{{ courseDetail.title }}</div> -->
        <el-tooltip class="courseTitle" effect="light" :content="courseDetail.title" placement="top">
          <div>{{ courseDetail.title }}</div>
        </el-tooltip>
        <div class="ml">目录</div>
        <div class="cru_selectBox">
          <div v-for="(item, stageIndex) in navList" :key="stageIndex">
            <div class="blue_box_one" @click="get(stageIndex)">
              <div>第{{ stageIndex + 1 }}阶段</div>
              <div>{{ item.dyName }}</div>
            </div>
            <div class="twoChild" :class="{ navActive: item.isOpen }">
              <div class="navChild" v-for="(nav, navIndex) in item.task" :key="navIndex">
                <div class="navTask" @click="openTask(stageIndex, navIndex, nav.id)" :class="{
                  openTaskActive:
                    navIndex == taskCount &&
                    nav.id == navId &&
                    stageIndex == courseType,
                }">
                  <div class="vedioNav" :class="{
                    isClick:
                      navIndex == taskCount &&
                      nav.id == navId &&
                      stageIndex == courseType,
                  }" style="margin: 0">
                    任务{{ navIndex + 1 }}
                  </div>
                  <el-tooltip class="navTaskname item" effect="light" :content="nav.taskName" placement="top">
                    <div :style="{
                      width:
                        IsLookOpen && !nav.isLook
                          ? 'calc(100% - 75px)'
                          : 'auto',
                    }">
                      {{ nav.taskName }}
                    </div>
                  </el-tooltip>
                  <img src="@/assets/lock.png" v-if="IsLookOpen && !nav.isLook" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body_student">
        <div class="new_top" style="
            position: fixed;
            top: 0;
            left: 20.7%;
            width: 80%;
            z-index: 999;
            box-shadow: 0px 9px 0 0 #f2f2f2;
          ">
          <div class="courseIndex">
            <div>第{{ courseType - 0 + 1 }}阶段</div>
            <el-tooltip effect="light" :content="chapInfoList[courseType].dyName" placement="top">
              <div>{{ chapInfoList[courseType].dyName }}</div>
            </el-tooltip>
            <div>任务{{ taskCount + 1 }}</div>
          </div>
          <div class="btnAll">
            <div class="returnBtn" @click="nextOrpreSteps(0)">上一步</div>
            <div class="returnBtn" @click="nextOrpreSteps(1)">下一步</div>
            <!-- <div class="returnBtn" @click="allScrell">全屏</div> -->
            <div class="returnBtn" @click="startRecording" v-if="(!videoStart && tType == 1 || tType == 4)">开始录制</div>
            <div class="returnBtn" @click="stopRecording" v-else-if="(tType == 1 || tType == 4)"
              style="background:#ee5255">下载录制</div>
            <div class="returnBtn" @click="juriVisible = true" v-if="tType == 1">
              权限
            </div>
            <div class="returnBtn" style="background: #5c6f97" @click.stop="
              goTo(
                '/courseDetailGM?userid=' +
                userid +
                '&oid=' +
                oid +
                '&org=' +
                org +
                '&cid=' +
                classId +
                '&courseId=' +
                id +
                '&tType=' +
                tType +
                '&screenType=' +
                screenType
              )
            ">
              返回
            </div>
          </div>
        </div>
        <!-- v-for="(task, index) in chapInfoList[courseType].chapterInfo[0]
            .taskJson"
        :key="index"-->
        <div class="isNoMessage" v-if="
          chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
            .chapterData.length == 0 &&
          chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
            .toolChoose[0].tool.length == 0 &&
          chapInfoList[courseType].chapterInfo[0].video.length == 0 &&
          chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
            .taskDetail == '' &&
          !chapInfoList[courseType].chapterInfo[0].taskJson[taskCount].eList
        ">
          <img src="@/assets/icon/isNoMessage.png" alt />
        </div>
        <div class="study_top" :class="{ pzClass: pzDialog }">
          <div class="vedioBox" v-if="
            vedio[taskCount].length > 0 ||
            chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
              .taskDetail != '' ||
            chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
              .chapterData.length > 0
          ">
            <div class="checkbox">
              <div class="check" style="font-size: 25px" :id="
                chapInfoList[courseType].chapterInfo[0].taskJson[taskCount].id
              ">
                <!-- {{ taskCount + 1 }}
                {{ chapInfoList[courseType].chapterInfo[0].taskJson[taskCount].task }}-->
                学一学
              </div>
            </div>
            <div class="student_head" v-if="
              vedio[taskCount].length > 0 ||
              textList[taskCount].length > 0 ||
              lineList[taskCount].length > 0 ||
              file[taskCount].length > 0 ||
              chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
                .taskDetail != ''
            ">
              <div class="taskBox">
                <div style="
                    display: flex;
                    flex-wrap: nowrap;
                    flex-direction: column;
                    position: relative;
                  ">
                  <div style="padding: 15px 0 15px 20px" v-if="
                    chapInfoList[courseType].chapterInfo[0].taskJson[
                      taskCount
                    ].taskDetail != ''
                  " v-html="
  chapInfoList[courseType].chapterInfo[0].taskJson[
    taskCount
  ].taskDetail
    ? chapInfoList[courseType].chapterInfo[0].taskJson[
      taskCount
    ].taskDetail
    : '暂无描述'
">
                    <!-- <span style="color: #cbcbcb">任务描述</span> -->
                    <!-- {{
                        chapInfoList[courseType].chapterInfo[0].taskJson[
                          taskCount
                        ].taskDetail
                          ? chapInfoList[courseType].chapterInfo[0].taskJson[
                              taskCount
                            ].taskDetail
                          : "暂无描述"
                    }}-->
                  </div>
                </div>
              </div>
              <div class="vedioTaskBox">
                <div class="box_course" v-if="
                  vedio[taskCount].length > 0 ||
                  textList[taskCount].length > 0 ||
                  lineList[taskCount].length > 0 ||
                  file[taskCount].length > 0
                ">
                  <div class="wheel" v-if="
                    vedio.length &&
                    vedio[taskCount] &&
                    vedio[taskCount].length > 0 &&
                    showType == 0
                  ">
                    <div class="workd_media" style="height: 100%">
                      <video-player class="video-player vjs-custom-skin" :playsinline="true"
                        :options="playerO[taskCount]" @play="onPlayerPlay($event)"
                        style="width: 90%; height: 100%; margin: 0 0 0 30px"></video-player>
                    </div>
                  </div>
                  <div class="wheel" v-if="showType == 1" style="
                      box-shadow: 0 0 6px 1px #f2f2f2;
                      width: 95%;
                      margin: 0 auto;
                      background: #f1f1f1;
                    ">
                    <div class="title">查看文档</div>
                    <el-form class="textBox">
                      <el-form-item class="textTitle">
                        <div style="
                            font-size: 22px;
                            max-height: 100px;
                            overflow: auto;
                          ">
                          {{ text.name }}
                        </div>
                      </el-form-item>
                      <!-- <div style="color: #918f8f; width: 85%">文档内容</div> -->
                      <div v-html="text.url" class="textContent"></div>
                    </el-form>
                  </div>
                  <div class="wheel" v-if="showType == 2" style="height: 650px; width: 95%; margin: 0 auto">
                    <iframe style="width: 100%; height: 100%; border: none" :src="pptImgUrl1"></iframe>
                  </div>
                  <div class="wheel" v-if="showType == 3" style="height: 650px; width: 95%; margin: 0 auto">
                    <!-- <iframe
                      style="width: 100%; height: 100%; border: none"
                      :src="pptImgUrl1"
                    ></iframe>-->
                    <pdf :pdfUrl="pptImgUrl1" style="width: 100%; height: 100%; overflow: auto"></pdf>
                  </div>
                  <div class="wheel" v-if="showType == 4" style="height: 650px; width: 95%; margin: 0 auto">
                    <el-image :src="pptImgUrl1" fit="cover" style="width: 100%"></el-image>
                  </div>
                </div>
                <!-- :class="
                    vedio[taskCount].length == 0 && file[taskCount].length == 0
                      ? 'listNoVedio'
                      : ''
                "-->
                <!-- :class="
                    vedio[taskCount].length == 0 &&
                    file[taskCount].length == 0 &&
                    textList[taskCount].length == 0
                      ? 'listNoVedio'
                      : ''
                  " -->
                <div class="vedioList" v-if="
                  (vedio.length &&
                    vedio[taskCount] &&
                    vedio[taskCount].length > 0) ||
                  (textList.length &&
                    textList[taskCount] &&
                    textList[taskCount].length > 0) ||
                  (lineList.length &&
                    lineList[taskCount] &&
                    lineList[taskCount].length > 0) ||
                  (file.length &&
                    file[taskCount] &&
                    file[taskCount].length > 0)
                ">
                  <div class="navTitile">内容列表：</div>
                  <div class="navBox">
                    <div v-show="
                      vedio.length &&
                      vedio[taskCount] &&
                      vedio[taskCount].length > 0
                    ">
                      <!-- <div
                        class="vedioNav"
                        style="
                          width: 80px;
                          min-width: 80px;
                          height: 30px;
                          line-height: 36px;
                          font-size: 16px;
                          border-radius: 10px;
                        "
                      >
                        视频
                      </div> -->
                      <div class="vedioTimeBox" v-for="(media, vedioIndex) in vedio[taskCount]" :key="vedioIndex + '1'"
                        @click="lookVedio(media.url, vedioIndex)">
                        <!-- <div class="media" style="width: 90px; height: 60px; position: relative">
                          <img style="height: 90px; width: 160px" :src="
                            media.cover != null && media.cover != ''
                              ? JSON.parse(media.cover).length > 0
                                ? JSON.parse(media.cover)[0].url
                                : mr
                              : mr
                          " alt />
                        </div> -->
                        <!-- <div class="vedioTime">
                            {{ vedioTime[vedioIndex] }}
                          </div> -->
                        <!-- <div class="vedioName">{{ media.name }}</div> -->
                        <div class="vedioName" :class="
                          isClickNav == 'video' + vedioIndex
                            ? 'isClickNav'
                            : ''
                        ">
                          {{ media.name }}
                        </div>
                      </div>
                    </div>
                    <div v-show="
                      textList.length &&
                      textList[taskCount] &&
                      textList[taskCount].length > 0
                    " class="newNav" v-for="(text, textIndex) in textList[taskCount]" :key="textIndex + '2'"
                      @click="lookText(taskCount, textIndex)">
                      <!-- <div
                        class="vedioNav"
                        style="
                          width: 80px;
                          min-width: 80px;
                          height: 30px;
                          line-height: 36px;
                          font-size: 16px;
                          border-radius: 10px;
                        "
                      >
                        文档
                      </div> -->
                      <div style="width: calc(100% - 0px)">
                        <div class="navText" :class="
                          isClickNav == 'text' + textIndex ? 'isClickNav' : ''
                        ">
                          {{
                            textList[taskCount].length > 0 ? text.name : ""
                          }}.doc
                        </div>
                      </div>
                    </div>
                    <!-- <div
                    v-show="
                      chapInfoList.length &&
                      chapToolList[taskCount] &&
                      chapToolList[taskCount].length > 0
                    "
                    class="newNav"
                    v-for="(tools, toolsIndex) in chapToolList[taskCount]"
                    :key="toolsIndex + '3'"
                  >
                    <div class="vedioNav">工具</div>
                    <div>
                      <div
                        class="navText"
                        @click="lookTools(taskCount, toolsIndex)"
                      >
                        {{
                          chapToolList[taskCount].length > 0 ? tools.name : ""
                        }}
                      </div>
                    </div>
                    </div>-->
                    <div v-show="
                      lineList.length &&
                      lineList[taskCount] &&
                      lineList[taskCount].length > 0
                    " class="newNav" v-for="(lines, lineIndex) in lineList[taskCount]" :key="lineIndex + '4'"
                      @click="doUrl(lines.url, lineIndex)">
                      <!-- <div
                        class="vedioNav"
                        style="
                          width: 80px;
                          min-width: 80px;
                          height: 30px;
                          line-height: 36px;
                          font-size: 16px;
                          border-radius: 10px;
                        "
                      >
                        链接
                      </div> -->
                      <!-- <div style="width: calc(100% - 0px)">
                        <div
                          class="navText"
                          :class="isClickNav == lineIndex ? 'isClickNav' : ''"
                        >
                          <a
                            style="text-decoration: none; color: #000"
                            target="_Blank"
                            >{{ lines.url }}</a
                          >
                        </div>
                      </div> -->
                      <div style="width: calc(100% - 0px)">
                        <div class="navText" :class="
                          isClickNav == 'line' + lineIndex ? 'isClickNav' : ''
                        ">
                          {{ lines.title ? lines.title : lines.url }}
                        </div>
                      </div>
                    </div>
                    <div class="newNav" v-show="
                      file.length &&
                      file[taskCount] &&
                      file[taskCount].length > 0
                    " v-for="(f, fileIndex) in file[taskCount]" :key="fileIndex" @click="downFile(f, fileIndex)">
                      <!-- <div
                        class="vedioNav"
                        style="
                          width: 80px;
                          min-width: 80px;
                          height: 30px;
                          line-height: 36px;
                          font-size: 16px;
                          border-radius: 10px;
                        "
                      >
                        文档
                      </div> -->
                      <div style="width: calc(100% - 0px)">
                        <div class="navText" :class="
                          isClickNav == 'word' + fileIndex ? 'isClickNav' : ''
                        ">
                          {{ f.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="padding: 10px 30px 0" v-if="showType == 2 || showType == 3">
                <el-button class="btnClassGM" type="primary"
                  @click="checkFileFull(showType, pptImgUrl1)">全屏查看</el-button>
                <el-button class="btnClassGM" type="primary" @click="downloadFile(pptImgUrl1)"
                  v-if="isClickNav.indexOf('line') == -1">文件下载</el-button>
                <el-button class="btnClassGM" v-if="isClickNav.indexOf('line') != -1" type="primary"
                  @click="openLine(pptImgUrl1)">打开链接
                </el-button>
              </div>
              <div style="padding: 0px 30px" v-if="showType == 1">
                <el-button class="btnClassGM" type="primary" @click="checkFileFull(showType, text)">全屏查看</el-button>
              </div>
            </div>
          </div>

          <div class="student_body" v-resize="resize">
            <!-- <div
              class="vedioBox"
              v-if="
                file.length && file[taskCount] && file[taskCount].length > 0
              "
            >
              <div class="queTop">
                <div class="question" style="width: 30px; margin-top: 5px">
                  <img src="@/assets/icon/fileIcon.png" alt />
                </div>
                <div class="queTitle">
                  <div>附件</div>
                </div>
              </div>
              <div class="filebox" style="width: 100%">
                <div
                  class="file"
                  v-for="(f, fileIndex) in file[taskCount]"
                  :key="fileIndex"
                  @click="downFile(f, fileIndex)"
                >
                  <img :src="require('@/assets/file.png')" alt />
                  <div>{{ f.name }}</div>
                </div>
              </div>
              <div class="upFile" v-if="type == 3">提交</div>
            </div>-->
            <div class="vedioBox" v-if="
              chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
                .toolChoose[0].tool &&
              chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
                .toolChoose[0].tool.length &&
              chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
                .toolChoose[0].tool.length > 0
            ">
              <div class="queTop" style="
                  font-size: 25px;
                  padding: 15px 0 15px 30px;
                  font-weight: bold;
                ">
                <!-- <div class="question" style="width: 30px">
                  <img src="@/assets/icon/toolIcon.png" alt />
                </div>
                <div class="queTitle">
                  <div>工具</div>
                </div>-->
                练一练
              </div>
              <div class="toolHeng2" style="position: relative">
                <div class="filebox" style="flex-wrap: nowrap; margin: 0 20px" v-for="(tool, toolIndex) in chapInfoList[courseType]
                .chapterInfo[0].taskJson[taskCount].toolChoose" :key="toolIndex">
                  <div class="bzBox">
                    <div></div>
                    <div>步骤{{ toolIndex + 1 }}</div>
                  </div>

                  <div class="toolBox">
                    <div>
                      <!-- v-for="(itemTool, indexTool) in toolTypeList"
                      :key="indexTool"-->

                      <!-- <div class="iframeBox">
                      <div
                        class="addPoint isBorder"
                        v-for="(tooC, toolCIndex) in tool.tool"
                        :key="toolCIndex"
                      >
                        <div v-if="tooC == 1" style="border: 1px soild #ccc">
                          <div
                            class="iframeName"
                          >
                            电子白板
                          </div>
                          <iframe
                            src="https://iwb.cocorobo.cn/"
                            ref="whiteBoard"
                          ></iframe>
                        </div>
                      </div>
                      </div>-->
                      <div class="noiframeBox">
                        <div class="addPoint" v-for="(tooC, toolCIndex) in tool.tool" :key="toolCIndex">
                          <div v-if="tooC == 1">
                            <img src="@/assets/icon/secondToolList/whiteBoard.png" alt
                              @click="addTools(tooC, toolIndex, taskCount)" />
                            <div style="margin: 5px 0">电子白板</div>
                          </div>
                          <div v-if="tooC == 3">
                            <img src="@/assets/icon/secondToolList/mindMapping.png" alt
                              @click="addTools(tooC, toolIndex, taskCount)" />
                            <div style="margin: 5px 0">思维导图</div>
                          </div>
                          <div v-if="tooC == 6">
                            <img src="@/assets/icon/secondToolList/doc.png" alt
                              @click="addTools(tooC, toolIndex, taskCount)" />
                            <div style="margin: 5px 0">协同文档</div>
                          </div>
                          <div v-if="tooC == 7">
                            <img src="@/assets/icon/secondToolList/mindNetwork.png" alt
                              @click="addTools(tooC, toolIndex, taskCount)" />
                            <div style="margin: 5px 0">思维网格</div>
                          </div>
                          <div v-if="tooC == 8">
                            <img src="@/assets/icon/secondToolList/library.png" alt
                              @click="addTools(tooC, toolIndex, taskCount)" />
                            <div style="margin: 5px 0">素材库</div>
                          </div>
                          <div v-if="tooC == 17">
                            <img src="@/assets/icon/secondToolList/library.png" alt
                              @click="addTools(tooC, toolIndex, taskCount)" />
                            <div style="margin: 5px 0">学习资料</div>
                          </div>
                          <div v-if="tooC == 2">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/secondToolList/note.png" alt />
                            <div style="margin: 5px 0">便签</div>
                          </div>
                          <div v-if="tooC == 4">
                            <img @click="addTools(tooC, toolIndex, taskCount)" src="@/assets/icon/thirdToolList/ask.png"
                              alt />
                            <div style="margin: 5px 0">问卷调查</div>
                          </div>
                          <div v-if="tooC == 45">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/choose.png" alt />
                            <div style="margin: 5px 0">选择题</div>
                          </div>
                          <!-- <div v-if="tooC == 5">
                            <img
                              @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/score.png"
                              alt
                            />
                            <div style="margin: 5px 0">量规评分</div>
                          </div> -->
                          <div v-if="tooC == 10">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/time.png" alt />
                            <div style="margin: 5px 0">倒计时</div>
                          </div>
                          <div v-if="tooC == 15">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/answer.png" alt />
                            <div style="margin: 5px 0">问答工具</div>
                          </div>
                          <div v-if="tooC == 26">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/courseDesign.png" alt />
                            <div style="margin: 5px 0">课程设计</div>
                          </div>
                          <div v-if="tooC == 18">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/trainPlatform.png" alt />
                            <div style="margin: 5px 0">训练服务器</div>
                          </div>
                          <div v-if="tooC == 16">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/work.png" alt />
                            <div style="margin: 5px 0">作业提交</div>
                          </div>
                          <div v-if="tooC == 21">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/fourthToolList/program.png" alt />
                            <div style="margin: 5px 0">编程平台</div>
                          </div>
                          <div v-if="tooC == 22">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/fourthToolList/program.png" alt />
                            <div style="margin: 5px 0">AI体验</div>
                          </div>
                          <div v-if="tooC == 23">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/fourthToolList/program.png" alt />
                            <div style="margin: 5px 0">Python</div>
                          </div>
                          <div v-if="tooC == 24">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/fourthToolList/AIprogram.png" alt />
                            <div style="margin: 5px 0">AI平台</div>
                          </div>
                          <div v-if="tooC == 25">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/evalua.png" alt />
                            <div style="margin: 5px 0">目标管理</div>
                          </div>
                          <div v-if="tooC == 31">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/secondToolList/networkPanel.png" alt />
                            <div style="margin: 5px 0">数学画板</div>
                          </div>
                          <div v-if="tooC == 28">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/secondToolList/translation.png" alt />
                            <div style="margin: 5px 0">翻译</div>
                          </div>
                          <div v-if="tooC == 37">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/secondToolList/mohe.png" alt />
                            <div style="margin: 5px 0">魔盒识字</div>
                          </div>
                          <div v-if="tooC == 38">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/secondToolList/24game.png" alt />
                            <div style="margin: 5px 0">24点</div>
                          </div>
                          <div v-if="tooC == 39">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/secondToolList/GeoGebra.png" alt />
                            <div style="margin: 5px 0">GeoGebra</div>
                          </div>
                          <div v-if="tooC == 32">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/code.png" alt />
                            <div style="margin: 5px 0">源码编辑</div>
                          </div>
                          <div v-if="tooC == 40">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/secondToolList/eval.png" alt />
                            <div style="margin: 5px 0">学生评价</div>
                          </div>
                          <div v-if="tooC == 41">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/select.png" alt />
                            <div style="margin: 5px 0">选择填空</div>
                          </div>
                          <div v-if="tooC == 44">
                            <img @click="addTools(tooC, toolIndex, taskCount)"
                              src="@/assets/icon/thirdToolList/hanClass.png" alt />
                            <div style="margin: 5px 0">汉字宫</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tooldetail" v-if="tool.toolDetail != ''">
                      <!-- <div class="toolTitle">工具描述</div> -->
                      <div v-html="contentConvent(tool.toolDetail)">
                        <!-- {{ contentConvent(tool.toolDetail) }} -->
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(16) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex">
                        <div class="workImg" v-if="w.type == 0">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="workImg" v-if="w.type == 1">
                          <img :src="word" @click="openFile(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="workImg" v-if="w.type == 3">
                          <img style="cursor: pointer" :src="video" @click="openVideo(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(4) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="isWorksName" v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex" @click="
                        openTools(4, toolIndex, taskCount, w.works, w.sName)
                      ">
                        {{ w.sName }}
                        <img class="deleteImg deleteImg2" src="@/assets/deleteworks.png"
                          v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)" alt />
                      </div>
                      <!-- <div
                        class="works"
                        style="
                          width: 200px;
                          height: 140px;
                          border-radius: 10px;
                          box-shadow: 0 0 6px 1px #dfdada;
                          overflow: hidden;
                        "
                        v-for="(w, wIndex) in workStudent[toolIndex]"
                        :key="wIndex"
                      >
                        <div class="workImg">
                          <img
                            src="@/assets/icon/works/noImg.png"
                            @click="
                              openTools(
                                4,
                                toolIndex,
                                taskCount,
                                w.works,
                                w.sName
                              )
                            "
                            alt
                          />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                          <div>{{ w.time }}</div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(45) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="isWorksName" v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex" @click="
                        openTools(45, toolIndex, taskCount, w.works, w.sName)
                      ">
                        {{ w.sName }}
                        <img class="deleteImg deleteImg2" src="@/assets/deleteworks.png"
                          v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)" alt />
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(15) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="works" v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex">
                        <div class="workImg">
                          <!-- <img
                            src="@/assets/icon/works/noImg.png"
                            @click="openTools(15, toolIndex, taskCount, w.works)"
                            alt=""
                          />-->
                          <div class="answerBg">
                            <!-- <div>{{ w.sName }}</div> -->
                            <el-tooltip class="item" effect="light" :content="JSON.parse(w.works)[0].answer"
                              placement="top">
                              <div class="answerContent">
                                {{ JSON.parse(w.works)[0].answer }}
                              </div>
                            </el-tooltip>
                            <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                              :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                              {{ JSON.parse(w.score).wScore }}分
                            </div>
                            <div class="answerScore" @click.stop="openScore(w)"
                              v-else-if="courseDetail.userid == userid"
                              :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                              评分
                            </div>
                            <img class="deleteImg" src="@/assets/deleteworks.png"
                              v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                              alt />
                          </div>
                          <div class="comment">
                            <div class="worksName">
                              <div>{{ w.sName }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(1) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex">
                        <div class="workImg">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(3) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex">
                        <div class="workImg">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(6) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex">
                        <div class="workImg">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(7) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex">
                        <div class="workImg">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(26) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex">
                        <div class="workImg">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(16) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          border-radius: 15px;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex"
                        :class="w.type == 1 ? 'isTypeOne' : ''">
                        <div class="workImg" v-if="w.type == 0">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="workImg" v-if="w.type == 1">
                          <img :src="word" @click="openFile(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="workImg" v-if="w.type == 3">
                          <img style="cursor: pointer" :src="video" @click="openVideo(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>

                        <div class="comment" style="min-width: 200px">
                          <div class="worksName">
                            <div>{{ w.sName }}</div>
                          </div>
                          <div class="commentList">
                            <div class="commentList">
                              <div class="commentImg" @click="
                                isLikes(w.wid, userid, 1, null, w.isLikes)
                              ">
                                <img :src="w.isLikes == true ? likes : noLikes" alt="" />
                              </div>
                              <div>{{ w.likesCount }}</div>
                            </div>
                            <div class="commentList" style="margin-right: 15px">
                              <div class="commentImg" @click="commentOther(w, toolIndex, wIndex)">
                                <img src="@/assets/icon/comment/comment.png" alt="" />
                              </div>
                              <div>{{ w.commentCount }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(4) != -1 &&
                    (tool.askJson[0].answer ||
                      tool.askJson[0].answer === 0) &&
                    checkJson[toolIndex].length
                  " class="xuan_right_box">
                    <div class="tool_right_box" v-for="(item, index) in tool.askJson" :key="index">
                      <div>
                        <span>{{ index + 1 + "、" + item.askstitle }}</span>
                      </div>
                      <div class="right_box_xuan">
                        <span>正确率</span>
                        <span>{{
                        (checkJson[toolIndex][index].right
                          ? checkJson[toolIndex][index].right
                          : 0) + "%"
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="xuan_right_box" style="background: unset" v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(4) != -1
                  ">
                    <AskStatic v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    " :askJSON="tool" :checkJson="checkJson[toolIndex]"></AskStatic>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(4) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div>
                      <div class="worksDetailBox" v-if="
                        worksStudent.length &&
                        worksStudent[toolIndex].length > 0
                      ">
                        <div v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex" class="isWorksName" @click="
                          openTools(4, toolIndex, taskCount, w.works, w.sName)
                        ">
                          {{ w.sName }}
                          <img class="deleteImg deleteImg2" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <!-- <div class="works" style="
                            width: 200px;
                            height: 140px;
                            border-radius: 10px;
                            box-shadow: 0 0 6px 1px #dfdada;
                            overflow: hidden;
                          " v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex">
                          <div class="workImg">
                            <img src="@/assets/icon/works/noImg.png" @click="
                              openTools(
                                4,
                                toolIndex,
                                taskCount,
                                w.works,
                                w.sName
                              )
                            " alt />
                          </div>
                          <div class="worksName">
                            <div>{{ w.sName }}</div>
                            <div>{{ w.time }}</div>
                          </div>
                        </div> -->
                      </div>
                    </div>

                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(45) != -1 &&
                    (tool.testJson.testJson[0].answer ||
                      tool.testJson.testJson[0].answer === 0) &&
                    checkJson[toolIndex].length
                  " class="xuan_right_box">
                    <div class="tool_right_box" v-for="(item, index) in tool.testJson.testJson" :key="index">
                      <div>
                        <span>{{ index + 1 + "、" + item.teststitle }}</span>
                      </div>
                      <div class="right_box_xuan">
                        <span>正确率</span>
                        <span>{{
                        (checkJson[toolIndex][index].right
                          ? checkJson[toolIndex][index].right
                          : 0) + "%"
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="xuan_right_box" style="background: unset" v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(45) != -1
                  ">
                    <AskStatic2 v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    " :askJSON="tool" :checkJson="checkJson[toolIndex]"></AskStatic2>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(45) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div>
                      <div class="worksDetailBox" v-if="
                        worksStudent.length &&
                        worksStudent[toolIndex].length > 0
                      ">
                        <div v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex" class="isWorksName" @click="
                          openTools(
                            45,
                            toolIndex,
                            taskCount,
                            w.works,
                            w.sName
                          )
                        ">
                          {{ w.sName }}
                          <img class="deleteImg deleteImg2" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                      </div>
                    </div>

                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(15) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <div class="works" v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex">
                        <div class="workImg" style="
                            border-radius: 15px;
                            box-shadow: #eee 0px 0px 5px 5px;
                          ">
                          <!-- <img
                            src="@/assets/icon/works/noImg.png"
                            @click="openTools(15, toolIndex, taskCount, w.works)"
                            alt=""
                          />-->
                          <div class="answerBg" style="border-radius: 15px 15px 0 0"
                            @click="commentOther(w, toolIndex, wIndex)">
                            <!-- <div>{{ w.sName }}</div> -->
                            <el-tooltip class="item" effect="light" :content="JSON.parse(w.works)[0].answer"
                              placement="top">
                              <div class="answerContent">
                                {{ JSON.parse(w.works)[0].answer }}
                              </div>
                            </el-tooltip>
                            <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                              :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                              {{ JSON.parse(w.score).wScore }}分
                            </div>
                            <div class="answerScore" @click.stop="openScore(w)"
                              v-else-if="courseDetail.userid == userid"
                              :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                              评分
                            </div>
                            <img class="deleteImg" src="@/assets/deleteworks.png"
                              v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                              alt />
                          </div>
                          <div class="comment">
                            <div class="worksName">
                              <div>{{ w.sName }}</div>
                            </div>
                            <div class="commentList">
                              <div class="commentImg" @click="
                                isLikes(w.wid, userid, 1, null, w.isLikes)
                              ">
                                <img :src="w.isLikes == true ? likes : noLikes" alt="" />
                              </div>
                              <div>{{ w.likesCount }}</div>
                            </div>
                            <div class="commentList" style="margin-right: 15px">
                              <div class="commentImg" @click="commentOther(w, toolIndex, wIndex)">
                                <img src="@/assets/icon/comment/comment.png" alt="" />
                              </div>
                              <div>{{ w.commentCount }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(1) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          border-radius: 15px;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex">
                        <!-- @click="previewImg(w.works)" -->
                        <div class="workImg">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="comment" style="min-width: 200px">
                          <div class="worksName">
                            <div>{{ w.sName }}</div>
                          </div>
                          <div class="commentList">
                            <div class="commentList">
                              <div class="commentImg" @click="
                                isLikes(w.wid, userid, 1, null, w.isLikes)
                              ">
                                <img :src="w.isLikes == true ? likes : noLikes" alt="" />
                              </div>
                              <div>{{ w.likesCount }}</div>
                            </div>
                            <div class="commentList" style="margin-right: 15px">
                              <div class="commentImg" @click="commentOther(w, toolIndex, wIndex)">
                                <img src="@/assets/icon/comment/comment.png" alt="" />
                              </div>
                              <div>{{ w.commentCount }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(3) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          border-radius: 15px;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex">
                        <!-- @click="previewImg(w.works)" -->
                        <div class="workImg">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="comment" style="min-width: 200px">
                          <div class="worksName">
                            <div>{{ w.sName }}</div>
                          </div>
                          <div class="commentList">
                            <div class="commentList">
                              <div class="commentImg" @click="
                                isLikes(w.wid, userid, 1, null, w.isLikes)
                              ">
                                <img :src="w.isLikes == true ? likes : noLikes" alt="" />
                              </div>
                              <div>{{ w.likesCount }}</div>
                            </div>
                            <div class="commentList" style="margin-right: 15px">
                              <div class="commentImg" @click="commentOther(w, toolIndex, wIndex)">
                                <img src="@/assets/icon/comment/comment.png" alt="" />
                              </div>
                              <div>{{ w.commentCount }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(6) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          border-radius: 15px;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex">
                        <!-- @click="previewImg(w.works)" -->
                        <div class="workImg">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="comment" style="min-width: 200px">
                          <div class="worksName">
                            <div>{{ w.sName }}</div>
                          </div>
                          <div class="commentList">
                            <div class="commentList">
                              <div class="commentImg" @click="
                                isLikes(w.wid, userid, 1, null, w.isLikes)
                              ">
                                <img :src="w.isLikes == true ? likes : noLikes" alt="" />
                              </div>
                              <div>{{ w.likesCount }}</div>
                            </div>
                            <div class="commentList" style="margin-right: 15px">
                              <div class="commentImg" @click="commentOther(w, toolIndex, wIndex)">
                                <img src="@/assets/icon/comment/comment.png" alt="" />
                              </div>
                              <div>{{ w.commentCount }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(7) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          border-radius: 15px;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex">
                        <!-- @click="previewImg(w.works)" -->
                        <div class="workImg">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <div class="answerScore" v-if="w.score" @click.stop="openScore(w)"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            {{ JSON.parse(w.score).wScore }}分
                          </div>
                          <div class="answerScore" @click.stop="openScore(w)" v-else-if="courseDetail.userid == userid"
                            :class="{ rightW: w.userid == userid || tType == 1 || tType == 4 }">
                            评分
                          </div>
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="comment" style="min-width: 200px">
                          <div class="worksName">
                            <div>{{ w.sName }}</div>
                          </div>
                          <div class="commentList">
                            <div class="commentList">
                              <div class="commentImg" @click="
                                isLikes(w.wid, userid, 1, null, w.isLikes)
                              ">
                                <img :src="w.isLikes == true ? likes : noLikes" alt="" />
                              </div>
                              <div>{{ w.likesCount }}</div>
                            </div>
                            <div class="commentList" style="margin-right: 15px">
                              <div class="commentImg" @click="commentOther(w, toolIndex, wIndex)">
                                <img src="@/assets/icon/comment/comment.png" alt="" />
                              </div>
                              <div>{{ w.commentCount }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(26) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <div class="works" style="width: 240px; height: 140px; overflow: hidden"
                        v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex"
                        :class="w.type == 1 ? 'isTypeOne' : ''">
                        <div class="workImg" v-if="w.type == 0">
                          <img :src="w.works" @click="previewImg(w.works)" alt />
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="workImg" v-if="w.type == 1">
                          <img :src="word" @click="openFile(w.works)" alt />
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div>
                    </div>
                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(40) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          border-radius: 15px;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex"
                        :class="w.type == 1 ? 'isTypeOne' : ''">
                        <div class="workImg">
                          <img src="@/assets/icon/works/noImg.png" @click="openPj(w.works, toolIndex)" alt />
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="comment" style="min-width: 200px">
                          <div class="worksName">
                            <div>{{ w.sName }}</div>
                          </div>
                          <div class="commentList">
                            <div class="commentList">
                              <div class="commentImg" @click="
                                isLikes(w.wid, userid, 1, null, w.isLikes)
                              ">
                                <img :src="w.isLikes == true ? likes : noLikes" alt="" />
                              </div>
                              <div>{{ w.likesCount }}</div>
                            </div>
                            <div class="commentList" style="margin-right: 15px">
                              <div class="commentImg" @click="commentOther(w, toolIndex, wIndex)">
                                <img src="@/assets/icon/comment/comment.png" alt="" />
                              </div>
                              <div>{{ w.commentCount }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(40) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                        " v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex">
                        <div class="workImg">
                          <img src="@/assets/icon/works/noImg.png" @click="openPj(w.works, toolIndex)" alt />
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(41) != -1
                  ">
                    <AnswerData2 v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    " :problemJson="tool.selectJson.answer" :people="worksStudent[toolIndex]"></AnswerData2>
                  </div>
                  <div v-if="
                    tType &&
                    ((tType == 2 && sIsOpen == true) ||
                      tType == 1 ||
                      tType == 4) &&
                    tool.tool.indexOf(41) != -1
                  " class="worksBox">
                    <div class="zuoyeYulan" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="
                      worksStudent.length &&
                      worksStudent[toolIndex].length > 0
                    ">
                      <div v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex" class="isWorksName"
                        @click="openXz(w, toolIndex)">
                        {{ w.sName }}
                        <img class="deleteImg deleteImg2" src="@/assets/deleteworks.png"
                          v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)" alt />
                      </div>
                      <!-- <div
                        class="works"
                        style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                          border-radius: 15px;
                          box-shadow: 0 0 6px 1px #dfdada;
                        " v-for="(w, wIndex) in worksStudent[toolIndex]" :key="wIndex"
                        :class="w.type == 5 ? 'isTypeOne' : ''">
                        <div class="workImg">
                          <img src="@/assets/icon/works/noImg.png" @click="openXz(w, toolIndex)" alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div> -->
                    </div>
                    <div style="font-size: 18px">未提交</div>
                    <div class="noWorksS">
                      <div v-for="(s, sIndex) in noWorksS[toolIndex]" :key="sIndex" class="noWorksName">
                        {{ s.student }}
                      </div>
                    </div>
                  </div>
                  <div v-if="tType && tType == 2 && !sIsOpen && tool.tool.indexOf(41) != -1" class="worksBox">
                    <div class="zuoyeYulan" v-if="workStudent[toolIndex].length > 0">
                      <span>作业预览</span>
                      <el-button type="text" @click="jump()" v-if="tType == 2" class="buttonA">我的评价</el-button>
                    </div>
                    <div class="worksDetailBox" v-if="workStudent[toolIndex].length > 0">
                      <div class="works" style="
                          width: 200px;
                          height: 140px;
                          margin: 10px 10px 10px 0;
                        " v-for="(w, wIndex) in workStudent[toolIndex]" :key="wIndex">
                        <div class="workImg">
                          <img src="@/assets/icon/works/noImg.png" @click="openXz(w, toolIndex)" alt />
                          <img class="deleteImg" src="@/assets/deleteworks.png"
                            v-if="w.userid == userid || tType == 1 || tType == 4" @click.stop="deleteWorks(w.wid)"
                            alt />
                        </div>
                        <div class="worksName">
                          <div>{{ w.sName }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="upload_toolBtn" @click="addImg($event)">
                  上传文件
                  <input
                    type="file"
                    accept="image/png, image/gif, image/jpeg"
                    style="display: none"
                    @change="beforeUpload1($event, 2, index)"
                  />
                </div>-->
              </div>
            </div>
            <div class="vedioBox" v-if="
              chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
                .eList &&
              chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
                .eList.length &&
              chapInfoList[courseType].chapterInfo[0].taskJson[taskCount]
                .eList.length > 0 &&
              tType != 2
            ">
              <div class="queTop" style="
                  font-size: 25px;
                  padding: 15px 0 15px 30px;
                  font-weight: bold;
                ">
                <!-- <div class="question" style="width: 30px">
                  <img src="@/assets/icon/toolIcon.png" alt />
                </div>
                <div class="queTitle">
                  <div>工具</div>
                </div>-->
                评一评
              </div>
              <div class="evaCss" :class="{ evaCssMax: Stbodywidth < 974 }">
                <div class="elist_input">
                  <div v-for="(eItem, eIndex) in chapInfoList[courseType]
                  .chapterInfo[0].taskJson[taskCount].eList" :key="eIndex" class="elist_input_box">
                    <div style="width: 95%">
                      <div style="
                          display: flex;
                          flex-direction: row;
                          flex-wrap: nowrap;
                          align-items: center;
                        ">
                        <div style="max-width: calc(100% - 285px)">
                          <span>{{ eItem.value }}</span>
                        </div>
                        <div style="
                            padding-left: 25px;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                          ">
                          <el-rate v-model="eItem.score" :colors="colors" disabled></el-rate>
                        </div>
                      </div>
                      <div class="elist_inptu_text" style="padding-left: 10px">
                        <span v-if="eItem.detail != ''">{{
                          eItem.detail
                        }}</span>
                        <span v-else style="color: #b2b1b3; font-size: 14px">暂无描述...</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="evalua" style="
                    border: 1px solid #e5e5e5;
                    max-width: 650px;
                    width: 100%;
                    margin-top: 20px;
                    box-shadow: 3px 1px 15px 3px #e0e0e0;
                  ">
                  <div class="e_add_top">
                    <div class="e_add_title">
                      <span>目标管理名称</span>
                      <span>{{ eTitle }}</span>
                      <img src="@/assets/lineGM.png" class="cru_line" style="
                          width: 125px;
                          height: 20px;
                          bottom: -10px;
                          left: 120px;
                        " />
                      <!-- <el-input
                        v-model="eTitle"
                        placeholder="请输入名称"
                        @change="setMindData"
                      ></el-input>-->
                    </div>
                  </div>
                  <div class="e_add_content">
                    <div class="e_add_list_pbox">
                      <div class="e_add_list_pbox_title">
                        <span class="type_title">切换模式</span>
                        <div class="type_content">
                          <span :class="{ active: typeMode == 1 }" @click="typeMode = 1">目标树</span>
                          <span :class="{ active: typeMode == 2 }" @click="typeMode = 2">目标罗盘</span>
                          <span :class="{ active: typeMode == 3 }" @click="typeMode = 3">目标看板</span>
                        </div>
                      </div>
                      <div class="e_add_list_pbox_content">
                        <Mind :showBar="false" :mindData="data" style="width: 100%" v-show="typeMode == 1"></Mind>
                        <Sunburst :Josn="eJson" :num="eJSONNum" style="width: 100%" v-if="typeMode == 2"></Sunburst>
                        <SeeBoard :Josn="eJson" :num="eJSONNum" :ename="eTitle" style="width: 100%"
                          v-if="typeMode == 3"></SeeBoard>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              class="project_box"
              style="margin-top: 15px; padding-bottom: 30px"
            >
              <div
                style="
                  display: flex;
                  flex-wrap: nowrap;
                  flex-direction: column;
                  position: relative;
                "
              >
                <div class="queTop">
                  <div class="question">
                    <img src="@/assets/icon/homeWork.png" alt="" />
                  </div>
                  <div class="queTitle">
                    <div>作业提交<span>(提交图文视频等)</span></div>
                    <div>：任务：{{ task.task }}</div>
                  </div>
                </div>
                <div class="ediBottom">
                  <div
                    class="addEditor"
                    style="margin-top: 23px"
                    @click="openAddWork"
                    v-if="!isNoHomeWork"
                  >
                    选择文件
                  </div>
                  <div
                    class="addEditor"
                    style="margin-top: 23px"
                    @click="openAddWork"
                    v-else
                  >
                    已提交
                  </div>
                </div>
              </div>
            </div>-->
          </div>
        </div>
        <el-dialog title="作业提交" :visible.sync="dialogVisible" :append-to-body="true" width="500px"
          :before-close="handleClose" class="dialog_change">
          <div class="marginT">
            <div>上传文件</div>
            <div class="chapter_add" @click="addImg($event)" v-if="studyJuri[0].cover.length == 0">
              <div class="up_photo">
                <img src="@/assets/icon/uploadImg.png" alt />
              </div>
              <input type="file"
                accept="video/mp4, video/quicktime, video/x-msvideo,application/pdf, application/.ppt, .pptx, .xlsx, .xls, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/*"
                capture="camera" style="display: none" @change="beforeUpload1($event, 1)" />
              <!-- <input
                type="file"
                accept="image/*"
                capture="camera"
                style="display: none"
                @change="beforeUpload1($event, 1)"
              /> -->
            </div>
            <div class="chapter_add" style="
                display: flex;
                width: 100%;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-start;
                padding: 15px 0;
              " v-if="studyJuri[0].cover.length > 0">
              <div class="upCover">
                <img :src="studyJuri[0].cover[0].url" alt v-if="fileType == 0" />
                <img :src="word" alt v-else-if="fileType == 1" />
                <img :src="video" alt v-else />
                <span class="picName">{{ studyJuri[0].cover[0].name }}</span>

                <div class="deleteWord" @click="clean(1)">
                  <img src="@/assets/icon/deleteWorks.png" alt />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="first">
            <div>作业名称:</div>
            <div>{{ chapInfoList[courseType].dyName }}</div>
          </div>
          <div style="font-size: 20px; margin-bottom: 10px">上传作业</div>
          <el-input
            type="textarea"
            resize="none"
            rows="7"
            placeholder="输入文字描述..."
            v-model="studyJuri[0].content"
          ></el-input>
          <div class="marginT">
            <div>上传图片</div>
            <div class="chapter_add" @click="addImg($event)">
              <div class="up_photo">
                <img src="@/assets/photo.png" alt />
              </div>
              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                @change="beforeUpload1($event, 1)"
              />
            </div>
            <div
              class="chapter_add"
              style="
                display: flex;
                width: 100%;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
              v-if="studyJuri[0].cover.length > 0"
            >
              <div
                v-for="(c, cIndex) in studyJuri[0].cover"
                :key="cIndex"
                class="upCover"
              >
                <img :src="c.url != null && c.url != '' ? c.url : mr" alt />
                <span class="picName">{{ c.name }}</span>

                <div class="deleteWord" @click="clean(1)">
                  <img src="@/assets/icon/delete.png" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="marginT">
            <div>上传视频</div>
            <div class="chapter_add" @click="addImg($event)">
              <div class="up_photo">
                <img src="@/assets/vidio.png" alt />
              </div>
              <input
                type="file"
                accept="video/mp4, video/quicktime, video/x-msvideo"
                style="display: none"
                @change="beforeUpload2($event, 2)"
              />
            </div>
            <div
              class="chapter_add"
              style="
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 100%;
                justify-content: flex-start;
              "
              v-if="studyJuri[0].upVedio.length > 0"
            >
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  flex-wrap: wrap;
                  align-content: flex-start;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <div
                  class="uploadVedio isAddThings"
                  v-for="(v, vIndex) in studyJuri[0].upVedio"
                  :key="vIndex"
                >
                  <img src="@/assets/uploadMp4.png" alt />
                  <span>{{ v.name }}</span>
                  <div class="deleteWord" @click="clean(2)">
                    <img src="@/assets/icon/delete.png" alt />
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <div class="upload_send" @click="addCourseWorks(taskCount)" v-if="!proVisible">提交</div>
        </el-dialog>
      </div>
    </div>
    <div class="pButton" @click="(pzDialog = true), selectPz()" v-if="tType == 4">
      <!-- 批 -->
      <img src="@/assets/pzBtn2.png" style="width: 25px" alt="" />
    </div>
    <div v-if="pzDialog == true" class="newDialogCss">
      <div class="pzTop2">
        <!-- <div>批注</div>
        <div @click="pzDialog = false">
          <img src="@/assets/close1.png" alt="" />
        </div> -->
        <div class="checkbox">
          <div class="check" style="font-size: 25px">评课笔记</div>
          <img src="@/assets/pzBtn.png" @click="pzDialog = false" alt="" />
        </div>
      </div>
      <div :class="pzList && pzList.length ? 'pzBox' : 'noPzBox'">
        <div class="pzListBox" v-if="pzList && pzList.length">
          <div class="pzList" v-for="(pz, pzIndex) in pzList" :key="pzIndex">
            <div class="pzNavTop">
              <div>批</div>
              <div>
                {{
                  pz.username.length > 5
                    ? pz.username.substring(0, 5) + "..."
                    : pz.username
                }}的批注
              </div>
              <div class="pzDelete" v-if="pz.userid == userid" @click="deletePz(pz.id)">
                删除
              </div>
            </div>
            <div class="pzContent cont" v-html="pz.content" v-if="pz.type == '1'">
              <!-- {{ }} -->
            </div>
            <div class="pzContent" v-if="pz.type == '2'">
              <audio :src="pz.content" controls="controls" ref="audio">
                Your browser does not support the audio element.
              </audio>
            </div>
            <div class="pzContent" v-if="pz.type == '3'">
              <img :src="pz.content" style="width: 90%; margin: 0 auto; display: block"
                @click="previewImg(pz.content)" />
            </div>
            <div class="time">
              {{ pz.time }}
            </div>
          </div>
        </div>
        <div class="noPz" v-else>
          <img src="@/assets/icon/noPz.png" alt="" />
        </div>
        <div class="addPzButton">
          <div class="addPz" @click="(addPzDialog = true), (pzType = 1)">
            添加批注
          </div>
          <div class="img1">
            <div @click="(addPzDialog = true), (pzType = 2)">
              <img src="@/assets/audio.png" /><span>音频</span>
            </div>
            <!-- <img src="@/assets/picture.png" @click="addPzDialog = true,pzType = 3" /> -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="addPzDialog == true" class="addDialogCss">
      <div class="pzTop">
        <div class="teacherPz">
          <div class="teacherPzImg">
            <img src="@/assets/icon/teacherPz.png" alt="" />
          </div>
          <div style="margin-left: 10px; height: 25px">教师批注</div>
        </div>
        <div @click="addPzDialog = false">
          <img src="@/assets/close1.png" alt="" />
        </div>
      </div>
      <div class="addPzBox">
        <div class="addPzCheck">
          <span :class="{ isChooseActive: pzType == 1 }" @click="pzType = 1">文本</span>
          <!-- <span :class="{isChooseActive:pzType==3}" @click="pzType = 3">图片</span> -->
          <span :class="{ isChooseActive: pzType == 2 }" @click="pzType = 2">音频</span>
        </div>
        <div style="height: calc(100% - 95px)">
          <!-- <textarea class="binfo_input pzConText" cols placeholder="请填写项目课程关键问题...." v-model="pzConText"
            v-if="pzType == 1"></textarea> -->
          <editor-bar class="binfo_input pzConText" style="width: 100% !important" placeholder="请输入任务描述"
            v-model="pzConText" @change="change" v-if="pzType == 1"></editor-bar>
          <Audio @addPz="addPz" class="pzAudioClass" v-if="pzType == 2"></Audio>
          <!-- <div class="pzAudioClass" v-if="pzType == 3">
            <div @click="addImg($event)">
              <el-button type="primary">上传图片</el-button>
              <input type="file" accept="image/png, image/gif, image/jpeg" style="display: none"
                @change="beforeUpload1($event, 4)" />
            </div>
          </div> -->
        </div>
        <div class="addTextCss" @click="addPz('1')" v-if="pzType == 1">
          确定
        </div>
      </div>
    </div>
    <div v-if="proVisible" class="mask">
      <div class="progressBox">
        <div class="lbox"><img src="@/assets/loading.gif" />上传中，请稍后</div>
        <el-progress :text-inside="true" :stroke-width="20" :percentage="progress" style="width: 80%"></el-progress>
      </div>
    </div>
    <el-dialog :visible.sync="pictureDialog" size="tiny">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <el-dialog :title="noteName != '' ? noteName : '查看问卷'" :visible.sync="dialogVisible5" :append-to-body="true"
      width="1000px" :before-close="handleClose" class="dialog_diy dialog_diy3">
      <div>
        <div class="a_add_title" style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          ">
          <div style="margin-right: 20px; font-size: 20px">标题:</div>
          <div style="font-size: 20px">{{ askJson.askTitle }}</div>
        </div>
        <div class="a_addBox">
          <div style="font-size: 16px; color: #c7c7c7">题目内容</div>
          <div class="a_add_box" v-for="(item1, index1) in askJson.askCount" :key="index1">
            <div class="a_add_head">
              <div style="display: flex">
                {{ index1 + 1 + "、" }}
                <div>题目：{{ askJson.askJson[index1].askstitle }}</div>
              </div>
              <img v-if="askJson.askJson[index1].img" :src="askJson.askJson[index1].img"
                style="height: 300px; margin-top: 10px; max-width: 100%" />
            </div>
            <div class="a_add_body">
              <div class="a_add_input">
                <el-radio-group v-model="radio[index1]">
                  <el-radio v-for="(item2, checkIndex) in askJson.askJson[index1]
                  .checkList" :key="checkIndex" :label="checkIndex" :disabled="isAnswer" class="redioStyle"><span
                      v-html="item2"></span></el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancelbtnGM" @click="dialogVisible5 = false" v-show="noteName == ''">取 消</el-button>
        <el-button class="btnClassGM" type="primary" @click="addStudentAsk" v-show="noteName == ''">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="noteName != '' ? noteName : '查看问卷'" :visible.sync="dialogVisibleChoice" :append-to-body="true"
      width="1000px" :before-close="handleClose" class="dialog_diy dialog_diy3">
      <div>
        <!-- <div class="a_add_title" style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          ">
          <div style="margin-right: 20px; font-size: 20px">标题:</div>
          <div style="font-size: 20px">{{ testJson.testTitle }}</div>
        </div> -->
        <div class="a_addBox">
          <div style="font-size: 16px; color: #c7c7c7">题目内容</div>
          <div class="a_add_box" v-for="(item1, index1) in testJson.testCount" :key="index1">
            <div class="a_add_head">
              <div style="display: flex">
                {{ index1 + 1 + "、" }}
                <div>题目：{{ testJson.testJson[index1].teststitle }}</div>
              </div>
              <img v-if="testJson.testJson[index1].img" :src="testJson.testJson[index1].img"
                style="height: 300px; margin-top: 10px; max-width: 100%" />
            </div>
            <div class="a_add_body">
              <div class="a_add_input">
                <el-radio-group v-model="radio[index1]" v-if="testJson.testJson[index1].type == '1'">
                  <el-radio v-for="(item2, checkIndex) in testJson.testJson[index1]
                  .checkList" :key="checkIndex" :label="checkIndex" :disabled="isAnswer" class="redioStyle"><span
                      v-html="item2"></span></el-radio>
                </el-radio-group>
                <el-checkbox-group v-model="radio[index1]" v-if="testJson.testJson[index1].type == '2'">
                  <el-checkbox v-for="(item2, checkIndex) in testJson.testJson[index1]
                  .checkList" :key="checkIndex" :label="checkIndex" :disabled="isAnswer" class="redioStyle">
                    <span v-html="item2"></span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancelbtnGM" @click="dialogVisibleChoice = false" v-show="noteName == ''">取 消</el-button>
        <el-button class="btnClassGM" type="primary" @click="addStudentTest" v-show="noteName == ''">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看富文本" :visible.sync="dialogVisible1" :append-to-body="true" width="500px"
      :before-close="handleClose" class="dialog_diy textCss">
      <el-form style="font-size: 20px">
        <el-form-item label="文本标题" class="textTitle">
          <div style="font-size: 20px">{{ text.name }}</div>
        </el-form-item>
        <div>富文本内容</div>
        <div v-html="text.url" style="font-size: 18px; padding: 40px 0 0 0"></div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btnClassGM" type="primary" @click="dialogVisible1 = false">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="文件预览" :visible.sync="dialogVisible3" width="50%" :before-close="handleClose" class="dialog_diy"
      :class="{ fullStyle: full }">
      <div slot="title" class="header-title">
        <div style="color: #fff">文件预览</div>
        <div style="position: absolute; top: 19px; right: 50px">
          <img src="@/assets/full.png" style="height: 16px; cursor: pointer" alt="" @click="fullTools" />
        </div>
      </div>
      <pdf v-if="showPDF" :pdfUrl="pptImgUrl" style="width: 100%; height: 520px; overflow: auto"
        :class="{ fullStyle: full }"></pdf>
      <iframe v-else :src="pptImgUrl" frameborder="0" width="100%" height="600" :class="{ fullStyle: full }"></iframe>
    </el-dialog>
    <el-dialog title="文件预览" :visible.sync="dialogVisible6" width="50%" :before-close="handleClose" class="dialog_diy">
      <iframe :src="pptImgUrl1" frameborder="0" width="100%" height="600"></iframe>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible4" :append-to-body="true" width="800px"
      :before-close="handleClose" class="dialog_diy notice">
      <div>此功能暂未开放！</div>
      <el-button type="primary" @click="dialogVisible4 = false">确定</el-button>
    </el-dialog>
    <el-dialog title="问答" :visible.sync="answerDialogVisible" :append-to-body="true" width="800px"
      :before-close="handleClose" class="dialog_diy">
      <div>
        <div style="
            display: flex;
            flex-wrap: nowrap;
            flex-direction: column;
            position: relative;
          ">
          <div class="queTop" style="padding: 20px 0 20px 0">
            <div class="question">
              <img src="@/assets/icon/question.png" alt />
            </div>
            <div class="queTitle">
              <div style="width: 90px; min-width: 90px">提问：</div>
              <div>{{ answerQ }}</div>
            </div>
          </div>
          <div class="ediBottom">
            <textarea rows="6" class="binfo_input" cols style="width: 95%; height: 120px"
              v-model="questionAnswer"></textarea>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button class="cancelbtnGM" @click="answerDialogVisible = false">取 消</el-button>
        <el-button class="btnClassGM" type="primary" @click="addQuestion">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="倒计时" :visible.sync="timeDialogVisible" :append-to-body="true" width="800px"
      :before-close="handleClose" class="dialog_diy">
      <div>
        <Time v-if="timeDialogVisible"></Time>
      </div>
      <div slot="footer">
        <el-button class="cancelbtnGM" @click="timeDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="权限设置" :visible.sync="juriVisible" :append-to-body="true" width="400px" :before-close="handleClose"
      class="dialog_diy">
      <div>
        <div class="open_box">
          <div class="switch_box">
            <span>允许学生查看所有作业</span>
            <el-switch v-model="sIsOpen" active-text="" class="switchCss" @change="updateSLook"></el-switch>
          </div>
          <div class="switch_box"
            v-if="courseDetail.userid == userid || courseDetail.course_teacher.indexOf(userid) != -1">
            <span>不允许学生查看所有阶段</span>
            <el-switch v-model="IsLookOpen" active-text="" class="switchCss" @change="updateLookOpen"></el-switch>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button class="cancelbtnGM" @click="juriVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看视频" :visible.sync="videoVisible" :append-to-body="true" width="1000px"
      :before-close="handleClose" class="dialog_diy1">
      <div class="workd_media" style="height: 100%" v-if="videoDetail.sources">
        <video-player class="video-player vjs-custom-skin" :playsinline="true" :options="videoDetail"
          @play="onPlayerPlay($event)" style="width: 100%; height: 100%"></video-player>
      </div>
      <div slot="footer">
        <el-button class="btnClassGM" style="color: #fff"
          @click="(videoVisible = false), (videoDetail.sources[0].src = '')">
          关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看详情" :visible.sync="commentDialogVisible" :append-to-body="true" width="800px"
      :before-close="handleClose" class="dialog_diy">
      <div class="commentTop">
        <div class="studentDetail">
          <div class="tx"><img src="@/assets/avatar.png" alt="" /></div>
          <div class="nameAndTime">
            <div style="margin-bottom: 5px">{{ commentDetail.sName }}</div>
            <div>{{ commentDetail.time }}</div>
          </div>
          <div class="returnBtn btnClassGM" style="margin-left: auto;width: 80px;" v-if="
            (commentDetail.works && commentDetail.type == 0) ||
            tType == 1 ||
            tType == 4
          " @click="showPicturePaint(commentDetail.img ? commentDetail.img : commentDetail.works)">
            教师批注
          </div>
        </div>
        <div class="worksAnswer" v-if="commentDetail.works && commentDetail.type == 2">
          {{ JSON.parse(commentDetail.works)[0].answer }}
        </div>
        <div class="worksAnswer" v-if="commentDetail.works && commentDetail.type == 1">
          <pdf v-if="showPDF" :pdfUrl="pptImgUrl" style="width: 100%; height: 520px; overflow: auto"
            :class="{ fullStyle: full }"></pdf>
          <iframe v-else :src="pptImgUrl" frameborder="0" width="100%" height="600"
            :class="{ fullStyle: full }"></iframe>
        </div>
        <div class="worksAnswer" v-if="commentDetail.works && commentDetail.type == 0">
          <img :src="commentDetail.works" alt="" @click="previewImg(commentDetail.works)" />
        </div>
        <div class="worksAnswer" v-if="commentDetail.works && commentDetail.type == 3">
          <video-player class="video-player vjs-custom-skin" :playsinline="true" :options="videoDetail"
            @play="onPlayerPlay($event)" style="width: 90%; height: 100%; margin: 0 0 0 30px"></video-player>
        </div>
        <div class="worksAnswer" v-if="commentDetail.works && commentDetail.type == 4">
          <div class="evalCss">
            <div class="nav">请选择星星进行评分</div>
            <div class="middleBox" v-if="eScore.eStar">
              <div class="pfBox" v-for="(e, eIndex) in rateJson" :key="eIndex">
                <div class="nameAndrate">
                  <div>{{ e.value }}</div>
                  <el-rate v-model="eScore.eStar[eIndex]" disabled></el-rate>
                </div>
                <div v-if="e.detail">{{ e.detail }}</div>
              </div>
              <div class="bz">
                <textarea disabled rows="4" class="pj" style="
                    padding: 10px 5px;
                    width: 70%;
                    background: #f7f6f9;
                    font-size: 14px;
                    text-indent: 10px;
                    color: #000;
                  " cols v-model="eScore.eBzText" placeholder="请输入评价内容..."></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="comment">
          <div class="commentList">
            <div class="commentImg">
              <img @click="
                isLikes(
                  commentDetail.wid,
                  userid,
                  1,
                  null,
                  commentDetail.isLikes
                )
              " :src="commentDetail.isLikes == true ? likes : noLikes" alt="" />
            </div>
            <div>{{ commentDetail.likesCount }}</div>
          </div>
          <div class="commentList">
            <div class="commentImg">
              <img src="@/assets/icon/comment/comment.png" alt="" />
            </div>
            <div>{{ commentDetail.commentCount }}</div>
          </div>
        </div>
        <div class="drawPBox" v-if="commentDetail.img">
          <span>教师批注</span>
          <img :src="commentDetail.img" alt="" @click="previewImg(commentDetail.img)" />
          <span class="deleteImg" v-if="tType == 1 || tType == 4" @click.stop="deletePicturePaint(commentDetail.wid)"
            style="font-size: 14px;width: auto !important;color: #b4b4b4;top: unset;bottom: 0;border: none;padding: 0;height: auto !important;margin: 0;">删除</span>
        </div>
      </div>
      <div class="commentBox">
        <div class="pl">评论：</div>
        <div style="max-height: 200px; overflow: auto">
          <div v-if="commentDetail.commentJson" style="padding: 10px 0 0 0">
            <div class="studentDetail" style="padding-top: 10px" v-for="(co, coIndex) in commentDetail.commentJson"
              :key="coIndex">
              <div class="tx" style="min-width: 50px">
                <img src="@/assets/avatar.png" alt="" />
              </div>
              <div class="plPerson">
                <div class="plName">
                  <div>{{ co.commentPeople }}</div>
                  <div style="margin-left: 5px">
                    {{ co.commentTime }}
                  </div>
                </div>
                <div class="plContent">{{ co.commentText }}</div>
              </div>
            </div>
          </div>
          <div v-else style="padding: 10px 0 0 0">暂无评论</div>
        </div>
      </div>
      <div style="margin-top: 10px">
        <div class="displayBox">
          <div style="
              color: #556db4;
              font-size: 14px;
              font-weight: bold;
              padding-bottom: 10px;
            ">
            评价
          </div>
          <div class="easy_comment">
            <div v-for="(p, pIndex) in PlTextList" :key="pIndex" @click="fastText(p, 1)">
              {{ p }}
            </div>
          </div>
        </div>

        <div>
          <textarea rows="3" class="pj" style="padding: 10px 5px" cols v-model="commentText"
            placeholder="请输入评论"></textarea>
        </div>
      </div>

      <div slot="footer">
        <el-button class="cancelbtnGM" @click="
          (commentDialogVisible = false),
          (commentIndexJson = {}),
          videoDetail.sources && videoDetail.sources[0]
            ? (videoDetail.sources[0].src = '')
            : ''
        ">取 消</el-button>
        <el-button class="btnClassGM" type="primary" @click="addComment(commentDetail.wid, userid, 2)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看文档" :visible.sync="fullDialogVisible" :append-to-body="true" width="100%"
      :before-close="handleClose" :show-close="false" class="dialog_diy full_diy" :class="{ full_diy2: fulltype == 3 }">
      <div slot="title" class="header-title">
        <div style="color: #fff">查看文档</div>
        <div @click="fullDialogVisible = false" style="
            cursor: pointer;
            position: absolute;
            top: 20px;
            right: 20px;
            color: #fff;
          ">
          退出全屏
        </div>
      </div>
      <div style="height: 100%">
        <iframe v-if="fulltype == 2" style="width: 100%; height: 100%; border: none" :src="fullUrl"></iframe>
        <pdf v-else-if="fulltype == 3" :pdfUrl="fullUrl" style="width: 100%; height: 100%; overflow: auto"></pdf>
        <div class="wheel" v-if="fulltype == 1" style="
            box-shadow: 0 0 6px 1px #f2f2f2;
            width: 100%;
            background: #f1f1f1;
          ">
          <div class="title" style="width: 100%; box-sizing: border-box">
            查看文档
          </div>
          <el-form class="textBox" style="height: 90%">
            <el-form-item class="textTitle">
              <div style="font-size: 22px; max-height: 100px; overflow: auto">
                {{ fullUrl.name }}
              </div>
            </el-form-item>
            <!-- <div style="color: #918f8f; width: 85%">文档内容</div> -->
            <div v-html="fullUrl.url" class="textContent" style="height: auto"></div>
          </el-form>
        </div>
      </div>
      <!-- <div slot="footer">
        <el-button @click="fullDialogVisible = false">关 闭</el-button>
      </div> -->
    </el-dialog>
    <el-dialog title="学生评价" :visible.sync="studentEvalDialogVisible" :append-to-body="true" width="800px"
      :before-close="handleClose" class="dialog_diy">
      <div class="evalCss">
        <div class="nav">请选择星星进行评分</div>
        <div class="middleBox" v-if="eScore.eStar">
          <div class="pfBox" v-for="(e, eIndex) in rateJson" :key="eIndex">
            <div class="nameAndrate">
              <div>{{ e.value }}</div>
              <el-rate v-model="eScore.eStar[eIndex]" :disabled="isStar"></el-rate>
            </div>
            <div v-if="e.detail">{{ e.detail }}</div>
          </div>
          <div class="easy_comment" v-if="isStar == false">
            <div v-for="(p, pIndex) in PlTextList" :key="pIndex" @click="fastText(p, 2)">
              {{ p }}
            </div>
          </div>
          <div class="bz">
            <textarea :disabled="isStar" rows="4" class="pj" style="
                padding: 10px 5px;
                width: 70%;
                background: #f7f6f9;
                font-size: 14px;
                text-indent: 10px;
              " cols v-model="eScore.eBzText" placeholder="请输入评价内容..."></textarea>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button class="cancelbtnGM" @click="studentEvalDialogVisible = false">取 消</el-button>
        <el-button class="btnClassGM" type="primary" @click="addBzWorks" v-if="!isStar">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择填空" :visible.sync="dialogVisibleSelect" :append-to-body="true" width="90%"
      :before-close="handleClose" class="dialog_diy dialog_diy3">
      <div v-if="selectJson">
        <div class="select_box2">
          <div class="select_box2_title">
            <div>选择填空</div>
            <div>请选择对应的答案进行答题！</div>
          </div>
          <div class="select_box2_box">
            <div class="select_box2_img">
              <img :src="selectJson.url" @click="previewImg(selectJson.url)" alt="" />
            </div>
            <div :class="isSelect ? 'rightWidthCss' : 'select_box2_answer'">
              <div style="padding-top: 15px">
                <div class="select_answer_title" v-if="isSelect">
                  {{ selectAnswer.stu }}
                </div>
                <div class="select_answer_title" v-else>
                  根据题目选择对应答案
                </div>
                <div class="select_box2_answer_box" v-for="(item2, checkIndex) in selectJson.select" :key="checkIndex">
                  <span style="min-width: 30px">{{ checkIndex + 1 }}、</span>
                  <el-select :disabled="isSelect" v-model="selectAnswer.answer[checkIndex]" placeholder="请选择正确答案">
                    <el-option v-for="(e, eIndex) in selectJson.select" :key="eIndex" :label="e" :value="eIndex">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="rightAnswerCss" v-if="isSelect && (tType == 1 || tType == 4)">
                <div v-for="(a, aIndex) in selectJson.answer" :key="aIndex" class="rightAnswer">
                  <div v-if="selectAnswer.answer[aIndex] === a" style="color: #767de1">
                    回答正确
                  </div>
                  <div v-else>回答错误</div>
                  <div style="margin-left: 10px" v-if="selectAnswer.answer[aIndex] !== a">
                    正确答案：
                  </div>
                  <div :class="
                    selectAnswer.answer[aIndex] === a ? 'blueCss' : 'redCss'
                  ">
                    {{ selectJson.select[a] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="upAnswerCss">
              <el-button class="btnClassGM" type="primary" @click="addSelectAnswer" v-if="!isSelect">提交答案</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="教师评分" :visible.sync="dialogVisibleScore" :append-to-body="true" width="800px"
      :before-close="handleClose" class="dialog_diy">
      <div>
        <div class="studentDetail">
          <div class="tx"><img src="@/assets/avatar.png" alt="" /></div>
          <div class="nameAndTime">
            <div style="margin-bottom: 5px">{{ commentDetail.sName }}</div>
            <div>{{ commentDetail.time }}</div>
          </div>
        </div>
        <div class="worksAnswer" v-if="commentDetail.works && commentDetail.type == 2">
          {{ JSON.parse(commentDetail.works)[0].answer }}
        </div>
        <div class="worksAnswer" v-if="commentDetail.works && commentDetail.type == 1">
          <pdf v-if="showPDF" :pdfUrl="pptImgUrl" style="width: 100%; height: 520px; overflow: auto"
            :class="{ fullStyle: full }"></pdf>
          <iframe v-else :src="pptImgUrl" frameborder="0" width="100%" height="600"
            :class="{ fullStyle: full }"></iframe>
        </div>
        <div class="worksAnswer" v-if="commentDetail.works && commentDetail.type == 0">
          <img :src="commentDetail.works" alt="" @click="previewImg(commentDetail.works)" />
        </div>
        <div class="worksAnswer" v-if="commentDetail.works && commentDetail.type == 3">
          <video-player class="video-player vjs-custom-skin" :playsinline="true" :options="videoDetail"
            @play="onPlayerPlay($event)" style="width: 90%; height: 100%; margin: 0 0 0 30px"></video-player>
        </div>
        <div class="scoreBox">
          <span class="t">请输入分数</span><el-input-number :disabled="courseDetail.userid != userid" v-model="wScore"
            :controls="false" :min="0" :max="100"></el-input-number>
        </div>
        <div class="scoreDetailBox">
          <span class="t">评分评论</span>
          <el-input type="textarea" :rows="5" :disabled="courseDetail.userid != userid" resize="none"
            v-model="scoreDetail" placeholder="请输入对学生的评价">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancelbtnGM" @click="
          (dialogVisibleScore = false),
          (commentIndexJson = {}),
          videoDetail.sources && videoDetail.sources[0]
            ? (videoDetail.sources[0].src = '')
            : ''
        ">取 消</el-button>
        <el-button type="primary" class="btnClassGM" v-if="courseDetail.userid == userid"
          @click="scoreWork(commentDetail.wid)">确 定</el-button>
      </span>
    </el-dialog>
    <ImgDraw :drawShow="drawShow" @closeDraw="closeDraw" @addImgDraw="addImgDraw" :bg="bg"></ImgDraw>
  </div>
</template>

<script>
import "../../common/aws-sdk-2.235.1.min.js";
// import pdf from "./components/pdf3";
import pdf from "../components/vpdfGM";
import AskStatic from "../components/askStaticGM";
import AskStatic2 from "../components/askStatic2GM";
import AnswerData2 from "../components/answerData2";
import EditorBar from "../tools/wangEnduit.vue";
import Time from "../tools/time.vue";
import Mind from "../tools/jsmind.vue";
import Sunburst from "../tools/sunburst";
import SeeBoard from "../tools/seeBoard";
import * as imageConversion from "image-conversion";
import Audio from "../components/audioGM.vue";
import ImgDraw from "../tools/imgDraw/imgDraw";
import RecordRTC from 'recordrtc';

export default {
  components: {
    EditorBar,
    Time,
    pdf,
    AskStatic,
    AskStatic2,
    Mind,
    Sunburst,
    SeeBoard,
    AnswerData2,
    Audio,
    ImgDraw,
  },
  data() {
    return {
      bg: false,
      drawShow: false,
      dialogVisible: false,
      commentDialogVisible: false,
      videoVisible: false,
      isStar: false,
      studentEvalDialogVisible: false,
      dialogVisibleSelect: false,
      dialogVisibleScore: false,
      bzText: "",
      commentDetail: [],
      selectAnswer: [],
      videoDetail: {},
      selectJson: {},
      eScore: { eBzText: "", eStar: [] },
      id: this.$route.query.courseId,
      userid: this.$route.query.userid,
      classId: this.$route.query.cid,
      // courseTypeLine: this.$route.query.type,
      oid: this.$route.query.oid,
      org: this.$route.query.org,
      tType: this.$route.query.tType,
      courseType: this.$route.query.type,
      screenType: this.$route.query.screenType,
      pptImgUrl: "",
      pptImgUrl1: "",
      commentText: "",
      full: false,
      sIsOpen: false,
      IsLookOpen: false,
      pzDialog: false,
      type: 1,
      vedio: [],
      text: [],
      textList: [],
      line: [],
      lineList: [],
      chapTools: [],
      chapToolList: [],
      file: [],
      vedioTime: [],
      upToolImg: "",
      rateList: {
        ca: 0,
      },
      rateParams: [],
      colors: ["#DFDFDF", "#DFDFDF", "#DFDFDF"],
      studyJuri: [
        {
          content: "",
          cover: [],
          upVedio: [],
          upFile: [],
        },
      ],
      mr: require("@/assets/vedioPic.png"),
      word: require("@/assets/icon/isWord.png"),
      video: require("@/assets/icon/isVideo.png"),
      noLikes: require("@/assets/icon/comment/noLikes.png"),
      likes: require("@/assets/icon/comment/likes.png"),
      scoreImg: require("@/assets/score.png"),
      courseDetail: {},
      isSelect: false,
      chapInfo: [],
      chapInfoList: [],
      taskCount: 0,
      imgList: [],
      noImgList: [],
      pzList: [],
      PlTextList: [
        "Excellent！",
        "nice！",
        "很有创意！",
        "还不错哦～",
        "继续努力哦～",
      ],
      isClickNav: "",
      navId: "",
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目   || "video/ogg"|| "video/webm"
            src: "", //url地址require("../@/assets/media/aaa.mp4")
          },
        ],
        // poster: require("../@/assets/tu31.png"), //你的封面地址
        // poster: dataRes.imgUrl, //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
      playerOptions1: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目   || "video/ogg"|| "video/webm"
            src: "", //url地址require("../@/assets/media/aaa.mp4")
          },
        ],
        // poster: require("../@/assets/tu31.png"), //你的封面地址
        // poster: dataRes.imgUrl, //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
      playerO: {},
      noneBtnImg: false,
      proVisible: false,
      progress: 0,
      questionAnswer: "",
      answerQ: "", //问答标题
      rateJson: [],
      wbCount: 0,
      wordCount: 0,
      mindCount: 0,
      askCount: 0,
      noteCount: 0,
      mindNetWorkCount: 0,
      libraryCount: 0,
      workCount: 0,
      timeCount: 0,
      answerCount: 0,
      trainCount: 0,
      evalCount: 0,
      dialogImageUrl: "",
      pictureDialog: false,
      toolTypeList: [],
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible6: false,
      dialogVisible4: false,
      isNoHomeWork: false,
      dialogVisible5: false,
      dialogVisibleChoice: false,
      answerDialogVisible: false,
      juriVisible: false,
      timeDialogVisible: false,
      radio: [],
      isAsk: false,
      askJson: {
        askCount: 1,
        askTitle: "",
        askJson: [{ askstitle: "", askItem: 1, checkList: [] }],
      },
      testJson: {},
      checkJson: [],
      askList: [],
      answerList: [],
      navList: [],
      addPzDialog: false,
      pzConText: "",
      worksStudent: [],
      workStudent: [],
      noWorksS: [],
      isWorksS: [],
      noWorksStudent: [],
      toolindex: 0,
      workTypeA: false,
      workTypeB: false,
      workTypeC: false,
      isAnswer: false,
      timer: null,
      showType: 0,
      fileType: 0,
      showPDF: false,
      noteName: "",
      evaJuri: [],
      evalua: "",
      eTitle: "",
      eName: "",
      eJson: {},
      fid: "", //一级
      sid: "", //二级
      tid: "", //二级
      typeMode: 1,
      eJSONNum: 0,
      Etype: 1,
      data: {
        meta: {
          name: "example",
          author: "dd@163.com",
          version: "0.2",
        },
        format: "node_array",
        data: [{ id: "root", isroot: true, topic: "" }],
      },
      fullDialogVisible: false,
      fulltype: "",
      fullUrl: "",
      commentIndexJson: {},
      Stbodywidth: 0,
      pzType: 1,
      wScore: 0,
      scoreDetail: "",
      videoStart: false,
      recorder: null,
    };
  },
  methods: {
    jump() {
      window.opener.postMessage({ tools: "43" }, "*");
    },
    previewImg(url) {
      this.$hevueImgPreview(url);
    },
    change(val) {
      console.log(val);
    },
    goTo(path) {
      this.$router.push(path);
    },
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.pictureDialog = true;
    },
    clean(type) {
      if (type == 1) {
        this.studyJuri[0].cover.splice(0, 1);
      } else if (type == 2) {
        this.studyJuri[0].upVedio.splice(0, 1);
      } else {
        this.studyJuri[0].upFile.splice(0, 1);
      }
    },
    handleClose(done) {
      if (this.videoDetail.sources && this.videoDetail.sources[0]) {
        this.videoDetail.sources[0].src = "";
      }
      this.commentIndexJson = {};
      done();
    },
    fullTools() {
      this.full = !this.full;
    },
    imgChange(file, fileList, type) {
      if (type == 1) {
        var _tmp = this.studyJuri[0].cover;
      } else if (type == 2) {
        var _tmp = this.studyJuri[0].upVedio;
      } else {
        var _tmp = this.studyJuri[0].upFile;
      }
      this.noneBtnImg = _tmp.length >= 1;
    },
    addImg(e) {
      var el = e.currentTarget;
      // this.$message.success('触发上传')
      el.getElementsByTagName("input")[0].click();
    },
    addSelectAnswer() {
      let params = [
        {
          uid: this.userid,
          cid: this.id,
          stage: this.courseType,
          task: this.taskCount,
          tool: this.toolindex,
          content: this.selectAnswer.answer,
          type: 7,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addCourseWorks", params)
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.dialogVisibleSelect = false;
          // this.selectAnswer = {};
          this.selectSWorks();
          this.selectStudent();
        })
        .catch((err) => {
          this.$message.error("提交失败");
          console.error(err);
        });
    },
    addCourseWorks(i) {
      var typesql;
      if (this.fileType === 0) {
        typesql = 1;
      } else if (this.fileType === 1) {
        typesql = 4;
      } else {
        typesql = 5;
      }
      if (!this.studyJuri[0].cover[0].url) {
        this.$message.error("请上传文件")
        return;
      }
      if (this.workTypeA == true) {
        this.$confirm(
          "您已经提交了该作业了，如果您再提交将覆盖上次提交的作业！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            let params = [
              {
                uid: this.userid,
                cid: this.id,
                stage: this.courseType,
                task: i,
                tool: this.toolindex,
                content: this.studyJuri[0].cover[0].url,
                type: typesql,
              },
            ];
            this.ajax
              .post(this.$store.state.api + "addCourseWorks", params)
              .then((res) => {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.studyJuri[0].cover = [];
                this.dialogVisible = false;
                this.getCourseDetail();
              })
              .catch((err) => {
                this.$message.error("提交失败");
                console.error(err);
              });
          })
          .catch(() => { });
      } else {
        let params = [
          {
            uid: this.userid,
            cid: this.id,
            stage: this.courseType,
            task: i,
            tool: this.toolindex,
            content: this.studyJuri[0].cover[0].url,
            type: typesql,
          },
        ];
        this.ajax
          .post(this.$store.state.api + "addCourseWorks", params)
          .then((res) => {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.studyJuri[0].cover = [];
            this.dialogVisible = false;
            this.getCourseDetail();
          })
          .catch((err) => {
            this.$message.error("提交失败");
            console.error(err);
          });
      }
    },
    selectWorksStudent() {
      let params = {
        oid: this.oid,
        cid: this.courseDetail.juri,
      };
      this.ajax
        .get(this.$store.state.api + "selectWorksStudent", params)
        .then((res) => {
          var a = res.data[0];
          for (var i = 0; i < this.isWorksS.length; i++) {
            this.noWorksS[i] = [];
            var studentK = [];
            if (this.isWorksS[i].length > 0) {
              for (var z = 0; z < this.isWorksS[i].length; z++) {
                studentK.push(this.isWorksS[i][z].uid);
              }
              studentK = studentK.join(",");
              for (var j = 0; j < a.length; j++) {
                if (studentK.indexOf(a[j].userid) == -1) {
                  this.noWorksS[i].push({ student: a[j].name });
                }
              }
            } else {
              for (var k = 0; k < a.length; k++) {
                this.noWorksS[i].push({ student: a[k].name });
              }
            }
          }
          this.$forceUpdate();
          if (
            Object.keys(this.commentDetail).length &&
            Object.keys(this.commentIndexJson).length &&
            !this.dialogVisibleScore
          ) {
            let a = 1
            for (var i = 0; i < this.worksStudent[this.commentIndexJson.toolIndex].length; i++) {
              let el = this.worksStudent[this.commentIndexJson.toolIndex][i]
              if (el.wid == this.commentDetail.wid) {
                a = 2
                this.commentOther(
                  this.worksStudent[this.commentIndexJson.toolIndex][
                  i
                  ],
                  this.commentIndexJson.toolIndex,
                  i
                );
                break;
              }
            }
            if (a === 1) {
              this.commentDetail = []
              this.commentIndexJson = {}
              this.commentDialogVisible = false;
              this.$message("此作业已被删除")
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectStudent() {
      //学生查看自己作业
      let params = {
        uid: this.userid,
        cid: this.id,
        s: this.courseType,
        t: this.taskCount,
      };
      this.ajax
        .get(this.$store.state.api + "selectStudentWorks", params)
        .then((res) => {
          var a =
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              this.taskCount
            ].toolChoose;
          var b = res.data[0];
          var c = ["PDF", "DOC", "DOCX", "PPT", "PPTX", "XLSX", "XLS"];
          var y = [
            "AVI",
            "NAVI",
            "MPEG",
            "ASF",
            "MOV",
            "WMV",
            "3GP",
            "RM",
            "RMVB",
            "FLV",
            "F4V",
            "H.264",
            "H.265",
            "REAL VIDEO",
            "MKV",
            "WebM",
            "HDDVD",
            "MP4",
            "MPG",
            "M4V",
            "MGV",
            "OGV",
            "QTM",
            "STR",
            "AMC",
            "DVX",
            "EVO",
            "DAT",
            "OGG",
            "OGM",
          ];
          for (var i = 0; i < a.length; i++) {
            this.workStudent[i] = [];
            for (var j = 0; j < b.length; j++) {
              if (i == b[j].tool) {
                if (
                  (b[j].type == 1 ||
                    b[j].type == 4 ||
                    b[j].type == 5 ||
                    b[j].type == 6 ||
                    b[j].type == 7) &&
                  a[i].tool[0] != 15 &&
                  a[i].tool[0] != 4 &&
                  a[i].tool[0] != 45
                ) {
                  if (
                    c.indexOf(
                      b[j].content
                        .split(".")
                      [b[j].content.split(".").length - 1].toLocaleUpperCase()
                    ) != -1
                  ) {
                    this.workStudent[i].push({
                      works: b[j].content,
                      sName: b[j].name,
                      score: b[j].score,
                      img: b[j].img,
                      type: 1,
                      time: b[j].time,
                      userid: b[j].userid,
                      wid: b[j].id,
                    });
                  } else if (
                    y.indexOf(
                      b[j].content
                        .split(".")
                      [b[j].content.split(".").length - 1].toLocaleUpperCase()
                    ) != -1
                  ) {
                    this.workStudent[i].push({
                      userid: b[j].userid,
                      wid: b[j].id,
                      works: b[j].content,
                      sName: b[j].name,
                      score: b[j].score,
                      img: b[j].img,
                      type: 3,
                      time: b[j].time,
                    });
                  } else if (b[j].type == 6) {
                    this.workStudent[i].push({
                      userid: b[j].userid,
                      wid: b[j].id,
                      works: b[j].content,
                      sName: b[j].name,
                      score: b[j].score,
                      img: b[j].img,
                      type: 4,
                      time: b[j].time,
                    });
                  } else if (b[j].type == 7) {
                    this.workStudent[i].push({
                      userid: b[j].userid,
                      wid: b[j].id,
                      works: b[j].content,
                      sName: b[j].name,
                      score: b[j].score,
                      img: b[j].img,
                      type: 5,
                      time: b[j].time,
                    });
                  } else if (b[j].type == 1 && a[i].tool[0] == b[j].atool) {
                    this.workStudent[i].push({
                      works: b[j].content,
                      sName: b[j].name,
                      score: b[j].score,
                      img: b[j].img,
                      type: 0,
                      time: b[j].time,
                      userid: b[j].userid,
                      wid: b[j].id,
                    });
                  } else if (b[j].type == 1 && !parseInt(b[j].atool)) {
                    this.workStudent[i].push({
                      works: b[j].content,
                      sName: b[j].name,
                      score: b[j].score,
                      img: b[j].img,
                      type: 0,
                      time: b[j].time,
                      userid: b[j].userid,
                      wid: b[j].id,
                    });
                  }
                } else if (b[j].type == 3 && a[i].tool[0] == 15) {
                  this.workStudent[i].push({
                    works: b[j].content,
                    sName: b[j].name,
                    score: b[j].score,
                    img: b[j].img,
                    type: 2,
                    time: b[j].time,
                    userid: b[j].userid,
                    wid: b[j].id,
                  });
                } else if (b[j].type == 2 && a[i].tool[0] == 4) {
                  //问卷
                  this.workStudent[i].push({
                    works: b[j].content,
                    sName: b[j].name,
                    score: b[j].score,
                    img: b[j].img,
                    type: 2,
                    time: b[j].time,
                    userid: b[j].userid,
                    wid: b[j].id,
                  });
                } else if (b[j].type == 8 && a[i].tool[0] == 45) {
                  //选择题
                  this.workStudent[i].push({
                    works: b[j].content,
                    sName: b[j].name,
                    score: b[j].score,
                    img: b[j].img,
                    type: 8,
                    time: b[j].time,
                    userid: b[j].userid,
                    wid: b[j].id,
                  });
                }
              }
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    openVideo(w) {
      this.videoDetail = {};
      this.playerOptions1.sources[0].src = w;
      this.videoDetail = this.playerOptions1;
      this.videoVisible = true;
    },
    isLikes(wid, uid, t, c, isLikes) {
      if (isLikes == false) {
        let params = [
          {
            wid: wid,
            lid: uid,
            t: t,
            c: c,
          },
        ];
        this.ajax
          .post(this.$store.state.api + "insertComment", params)
          .then((res) => {
            this.$message({
              message: "点赞成功",
              type: "success",
            });
            this.selectSWorks();
            this.selectStudent();
          })
          .catch((err) => {
            this.$message.error("点赞失败");
            console.error(err);
          });
      } else {
        let params = {
          wid: wid,
          lid: uid,
          type: t,
        };
        this.ajax
          .get(this.$store.state.api + "deleteComment", params)
          .then((res) => {
            this.$message({
              message: "取消点赞成功",
              type: "success",
            });
            this.selectSWorks();
            this.selectStudent();
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    commentOther(w, toolIndex, wIndex) {
      this.commentIndexJson = { toolIndex: toolIndex, wIndex: wIndex };
      this.commentDetail = [];
      this.commentDialogVisible = true;
      this.commentDetail = w;
      if (w.works && w.type == 1) {
        this.pptImgUrl = "";
        var a = ["PPT", "PPTX", "XLSX", "XLS", "DOC", "DOCX"];
        if (
          a.indexOf(
            w.works
              .split(".")
            [w.works.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl =
            "https://view.officeapps.live.com/op/view.aspx?src=" + w.works;
          this.showPDF = false;
        } else if (
          w.works
            .split(".")
          [w.works.split(".").length - 1].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl = w.works;
          this.showPDF = true;
        }
      } else if (w.works && w.type == 3) {
        this.videoDetail = {};
        this.playerOptions1.sources[0].src = w.works;
        this.videoDetail = this.playerOptions1;
        // this.videoVisible = true;
      } else if (w.works && w.type == 4) {
        this.eScore = JSON.parse(w.works);
        this.rateJson =
          this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
            this.taskCount
          ].toolChoose[toolIndex].rateJson;
      }
    },
    openScore(w) {
      this.wScore = 0;
      this.wScore = w.score ? JSON.parse(w.score).wScore : 0;
      this.scoreDetail = w.score ? JSON.parse(w.score).detail : "";
      this.commentDetail = [];
      this.dialogVisibleScore = true;
      this.commentDetail = w;

      if (w.works && w.type == 1) {
        this.pptImgUrl = "";
        var a = ["PPT", "PPTX", "XLSX", "XLS", "DOC", "DOCX"];
        if (
          a.indexOf(
            w.works
              .split(".")
            [w.works.split(".").length - 1].toLocaleUpperCase()
          ) != -1
        ) {
          this.pptImgUrl =
            "https://view.officeapps.live.com/op/view.aspx?src=" + w.works;
          this.showPDF = false;
        } else if (
          w.works
            .split(".")
          [w.works.split(".").length - 1].toLocaleUpperCase() == "PDF"
        ) {
          this.pptImgUrl = w.works;
          this.showPDF = true;
        }
      } else if (w.works && w.type == 3) {
        this.videoDetail = {};
        this.playerOptions1.sources[0].src = w.works;
        this.videoDetail = this.playerOptions1;
      }
    },
    addComment(wid, uid, t) {
      if (this.commentText == "") {
        this.$message.error("请输入评论");
        return;
      }
      let params2 = [
        {
          wid: wid,
          lid: uid,
          t: t,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "getComment", params2)
        .then((res) => {
          if (res.data[0].length > 0) {
            this.$message.error("一个作业只能评论一条");
          } else {
            let params = [
              {
                wid: wid,
                lid: uid,
                t: t,
                c: this.commentText,
              },
            ];
            this.ajax
              .post(this.$store.state.api + "insertComment", params)
              .then((res) => {
                this.$message({
                  message: "评论成功",
                  type: "success",
                });
                this.commentText = "";
                this.selectSWorks();
                this.selectStudent();
              })
              .catch((err) => {
                this.$message.error("评论失败");
                console.error(err);
              });
          }
        })
        .catch((err) => {
          // this.$message.error("评论失败");
          console.error(err);
        });

    },
    scoreWork(wid) {
      if (this.wScore == 0) {
        this.$message.error("请评分");
        return;
      }
      let params = [
        {
          wid: wid,
          score: JSON.stringify({
            wScore: this.wScore,
            detail: this.scoreDetail,
          }),
        },
      ];
      this.ajax
        .post(this.$store.state.api + "scoreWork", params)
        .then((res) => {
          this.$message({
            message: "评分成功",
            type: "success",
          });
          this.wScore = 0;
          this.scoreDetail = "";
          this.dialogVisibleScore = false;
          this.selectSWorks();
          this.selectStudent();
        })
        .catch((err) => {
          this.$message.error("评分失败");
          console.error(err);
        });
    },
    openXz(w, i) {
      this.selectJson = this.chapInfoList[this.courseType].chapterInfo[0]
        .taskJson[this.taskCount].toolChoose[i].selectJson
        ? JSON.parse(
          JSON.stringify(
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              this.taskCount
            ].toolChoose[i].selectJson
          )
        )
        : { url: "", select: [], answer: [] };
      var a = w.works.split(",");
      for (var k = 0; k < a.length; k++) {
        a[k] = parseInt(a[k]);
      }
      this.selectAnswer = { answer: a, stu: w.sName };
      this.isSelect = true;
      this.dialogVisibleSelect = true;
    },
    openPj(w, toolindex) {
      this.isStar = true;
      this.eScore = JSON.parse(w);
      this.rateJson =
        this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
          this.taskCount
        ].toolChoose[toolindex].rateJson;
      this.studentEvalDialogVisible = true;
    },
    deleteWorks(id) {
      this.$confirm("确定删除此作业吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = [
            {
              id: id,
            },
          ];
          this.ajax
            .post(this.$store.state.api + "deleteCourseWork", params)
            .then((res) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.selectStudent();
              this.selectSWorks();
              this.selectSLook();
            })
            .catch((err) => {
              this.$message.error("网络异常");
              console.error(err);
            });
        })
        .catch(() => { });
    },
    selectSWorks() {
      //教师查看全部作业
      let params = {
        cid: this.id,
        s: this.courseType,
        t: this.taskCount,
      };
      this.ajax
        .get(this.$store.state.api + "selectSWorks", params)
        .then((res) => {
          var a =
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              this.taskCount
            ].toolChoose;
          var b = res.data[0];
          var c = ["PDF", "DOC", "DOCX", "PPT", "PPTX", "XLSX", "XLS"];
          var y = [
            "AVI",
            "NAVI",
            "MPEG",
            "ASF",
            "MOV",
            "WMV",
            "3GP",
            "RM",
            "RMVB",
            "FLV",
            "F4V",
            "H.264",
            "H.265",
            "REAL VIDEO",
            "MKV",
            "WebM",
            "HDDVD",
            "MP4",
            "MPG",
            "M4V",
            "MGV",
            "OGV",
            "QTM",
            "STR",
            "AMC",
            "DVX",
            "EVO",
            "DAT",
            "OGG",
            "OGM",
          ];
          var d = res.data[1];
          var e = res.data[2];

          for (var i = 0; i < a.length; i++) {
            this.worksStudent[i] = [];
            this.isWorksS[i] = [];
            this.checkJson[i] = [];
            for (var j = 0; j < b.length; j++) {
              var likesCount = 0;
              var commentCount = 0;
              var isLikes = false;
              var commentJson = [];
              var data = b[j];
              if (i == b[j].tool) {
                if (data.type == 2 && a[i].tool[0] == 4) {
                  var checkL = JSON.parse(data.content)[0].anwer.split(",");
                  for (var z = 0; z < checkL.length; z++) {
                    if (!this.checkJson[i][z]) {
                      this.checkJson[i].push({
                        checkCount: [],
                        checkPerson: [],
                        rightPerson: [],
                      });
                    }
                    if (!this.checkJson[i][z].checkCount.length) {
                      this.checkJson[i][z].checkCount = [];
                      let _askItemCount = JSON.parse(data.content)[0].askJson
                        .askJson[z].askItem;
                      for (var aic = 0; aic < _askItemCount; aic++) {
                        this.checkJson[i][z].checkCount.push(0);
                      }
                    }
                    if (
                      (JSON.parse(data.content)[0].askJson.askJson[z].answer ||
                        JSON.parse(data.content)[0].askJson.askJson[z].answer ==
                        0) &&
                      JSON.parse(data.content)[0].askJson.askJson[z].answer ==
                      checkL[z]
                    ) {
                      this.checkJson[i][z].rightPerson.push(data.name);
                    }
                    this.checkJson[i][z].checkPerson[parseInt(checkL[z])]
                      ? this.checkJson[i][z].checkPerson[
                        parseInt(checkL[z])
                      ].push(data.name)
                      : (this.checkJson[i][z].checkPerson[parseInt(checkL[z])] =
                        [data.name]);
                    this.checkJson[i][z].checkCount[parseInt(checkL[z])]
                      ? this.checkJson[i][z].checkCount[parseInt(checkL[z])]++
                      : (this.checkJson[i][z].checkCount[
                        parseInt(checkL[z])
                      ] = 1);
                  }
                } else if (data.type == 8 && a[i].tool[0] == 45) {
                  var checkL = JSON.parse(data.content)[0].anwer;
                  for (var z = 0; z < checkL.length; z++) {
                    if (!this.checkJson[i][z]) {
                      this.checkJson[i].push({
                        checkCount: [],
                        checkPerson: [],
                        rightPerson: [],
                      });
                    }
                    if (!this.checkJson[i][z].checkCount.length) {
                      this.checkJson[i][z].checkCount = [];
                      let _askItemCount = JSON.parse(data.content)[0].testJson
                        .testJson[z].testItem;
                      for (var aic = 0; aic < _askItemCount; aic++) {
                        this.checkJson[i][z].checkCount.push(0);
                      }
                    }

                    if (checkL[z] instanceof Array) {
                      if (
                        JSON.parse(data.content)[0].testJson.testJson[
                          z
                        ].answer.join(",") == checkL[z].join(",")
                      ) {
                        this.checkJson[i][z].rightPerson.push(data.name);
                      }
                      for (var q = 0; q < checkL[z].length; q++) {
                        this.checkJson[i][z].checkPerson[parseInt(checkL[z][q])]
                          ? this.checkJson[i][z].checkPerson[
                            parseInt(checkL[z][q])
                          ].push(data.name)
                          : (this.checkJson[i][z].checkPerson[
                            parseInt(checkL[z][q])
                          ] = [data.name]);
                        this.checkJson[i][z].checkCount[parseInt(checkL[z][q])]
                          ? this.checkJson[i][z].checkCount[
                          parseInt(checkL[z][q])
                          ]++
                          : (this.checkJson[i][z].checkCount[
                            parseInt(checkL[z][q])
                          ] = 1);
                      }
                    } else {
                      if (
                        JSON.parse(data.content)[0].testJson.testJson[z]
                          .answer == checkL[z]
                      ) {
                        this.checkJson[i][z].rightPerson.push(data.name);
                      }
                      this.checkJson[i][z].checkPerson[parseInt(checkL[z])]
                        ? this.checkJson[i][z].checkPerson[
                          parseInt(checkL[z])
                        ].push(data.name)
                        : (this.checkJson[i][z].checkPerson[
                          parseInt(checkL[z])
                        ] = [data.name]);
                      this.checkJson[i][z].checkCount[parseInt(checkL[z])]
                        ? this.checkJson[i][z].checkCount[parseInt(checkL[z])]++
                        : (this.checkJson[i][z].checkCount[
                          parseInt(checkL[z])
                        ] = 1);
                    }
                  }
                }
                for (var k = 0; k < d.length; k++) {
                  //点赞
                  if (d[k].workId == b[j].id) {
                    likesCount++;

                    if (d[k].likesId == this.userid) {
                      isLikes = true;
                    }
                  }
                }
                for (var l = 0; l < e.length; l++) {
                  //评论
                  if (e[l].workId == b[j].id) {
                    if (e[l].comment != "") {
                      commentCount++;
                      commentJson.push({
                        commentText: e[l].comment,
                        commentTime: e[l].commentTime,
                        commentPeople: e[l].commentPeople,
                      });
                    }
                  }
                }
                if (
                  (b[j].type == 1 ||
                    b[j].type == 4 ||
                    b[j].type == 5 ||
                    b[j].type == 6 ||
                    b[j].type == 7) &&
                  a[i].tool[0] != 15 &&
                  a[i].tool[0] != 4 &&
                  a[i].tool[0] != 45
                ) {
                  if (
                    c.indexOf(
                      b[j].content
                        .split(".")
                      [b[j].content.split(".").length - 1].toLocaleUpperCase()
                    ) != -1
                  ) {
                    this.worksStudent[i].push({
                      userid: b[j].userid,
                      wid: b[j].id,
                      works: b[j].content,
                      sName: b[j].name,
                      type: 1,
                      time: b[j].time,
                      score: b[j].score,
                      img: b[j].img,
                      likesCount: likesCount,
                      commentCount: commentCount,
                      isLikes: isLikes,
                      commentJson: commentJson,
                    });
                  } else if (
                    y.indexOf(
                      b[j].content
                        .split(".")
                      [b[j].content.split(".").length - 1].toLocaleUpperCase()
                    ) != -1
                  ) {
                    this.worksStudent[i].push({
                      userid: b[j].userid,
                      wid: b[j].id,
                      works: b[j].content,
                      sName: b[j].name,
                      type: 3,
                      time: b[j].time,
                      score: b[j].score,
                      img: b[j].img,
                      likesCount: likesCount,
                      commentCount: commentCount,
                      isLikes: isLikes,
                      commentJson: commentJson,
                    });
                  } else if (b[j].type == 6) {
                    this.worksStudent[i].push({
                      userid: b[j].userid,
                      wid: b[j].id,
                      works: b[j].content,
                      sName: b[j].name,
                      type: 4,
                      time: b[j].time,
                      score: b[j].score,
                      img: b[j].img,
                      likesCount: likesCount,
                      commentCount: commentCount,
                      isLikes: isLikes,
                      commentJson: commentJson,
                    });
                  } else if (b[j].type == 7) {
                    this.worksStudent[i].push({
                      userid: b[j].userid,
                      wid: b[j].id,
                      works: b[j].content,
                      sName: b[j].name,
                      type: 5,
                      time: b[j].time,
                      score: b[j].score,
                      img: b[j].img,
                      likesCount: likesCount,
                      commentCount: commentCount,
                      isLikes: isLikes,
                      commentJson: commentJson,
                    });
                  } else if (b[j].type == 1 && a[i].tool[0] == b[j].atool) {
                    this.worksStudent[i].push({
                      userid: b[j].userid,
                      ateacher: b[j].ateacher,
                      wid: b[j].id,
                      works: b[j].content,
                      sName: b[j].name,
                      type: 0,
                      time: b[j].time,
                      score: b[j].score,
                      img: b[j].img,
                      likesCount: likesCount,
                      commentCount: commentCount,
                      isLikes: isLikes,
                      commentJson: commentJson,
                    });
                  } else if (b[j].type == 1 && !parseInt(b[j].atool)) {
                    this.worksStudent[i].push({
                      userid: b[j].userid,
                      ateacher: b[j].ateacher,
                      wid: b[j].id,
                      works: b[j].content,
                      sName: b[j].name,
                      type: 0,
                      time: b[j].time,
                      score: b[j].score,
                      img: b[j].img,
                      likesCount: likesCount,
                      commentCount: commentCount,
                      isLikes: isLikes,
                      commentJson: commentJson,
                    });
                  }
                } else if (b[j].type == 3 && a[i].tool[0] == 15) {
                  this.worksStudent[i].push({
                    userid: b[j].userid,
                    wid: b[j].id,
                    works: b[j].content,
                    sName: b[j].name,
                    type: 2,
                    time: b[j].time,
                    score: b[j].score,
                    img: b[j].img,
                    likesCount: likesCount,
                    commentCount: commentCount,
                    isLikes: isLikes,
                    commentJson: commentJson,
                  });
                } else if (b[j].type == 2 && a[i].tool[0] == 4) {
                  //问卷
                  this.worksStudent[i].push({
                    userid: b[j].userid,
                    wid: b[j].id,
                    works: b[j].content,
                    sName: b[j].name,
                    type: 2,
                    time: b[j].time,
                    score: b[j].score,
                    img: b[j].img,
                    likesCount: likesCount,
                    commentCount: commentCount,
                    isLikes: isLikes,
                    commentJson: commentJson,
                  });
                } else if (b[j].type == 8 && a[i].tool[0] == 45) {
                  //选择题
                  this.worksStudent[i].push({
                    userid: b[j].userid,
                    wid: b[j].id,
                    works: b[j].content,
                    sName: b[j].name,
                    type: 8,
                    time: b[j].time,
                    score: b[j].score,
                    img: b[j].img,
                    likesCount: likesCount,
                    commentCount: commentCount,
                    isLikes: isLikes,
                    commentJson: commentJson,
                  });
                }

                this.isWorksS[i].push({ uid: b[j].userid, sName: b[j].name });
              }
            }
            if (this.worksStudent[i] && this.worksStudent[i].length) {
              this.worksStudent[i] = this.worksStudent[i].sort(function (a, b) {
                let jscoreA = a.score ? JSON.parse(a.score).wScore : 0;
                let jscoreB = b.score ? JSON.parse(b.score).wScore : 0;
                var scoreA = parseFloat(jscoreA);
                var scoreB = parseFloat(jscoreB);
                if (scoreA == scoreB) {
                  return b.likesCount - a.likesCount;
                }
                return scoreB - scoreA;
              });
            }
          }

          for (var i = 0; i < a.length; i++) {
            for (var j = 0; j < b.length; j++) {
              var data = b[j];
              if (i == b[j].tool) {
                if (data.type == 2 || data.type == 8) {
                  for (var z = 0; z < this.checkJson[i].length; z++) {
                    this.checkJson[i][z].checkPerent = [];
                    this.checkJson[i][z].right = Math.round(
                      (this.checkJson[i][z].rightPerson.length /
                        parseInt(this.worksStudent[i].length)) *
                      100
                    );
                    let aaaa = this.checkJson[i][z];
                    console.log(aaaa);
                    for (
                      var k = 0;
                      k < this.checkJson[i][z].checkCount.length;
                      k++
                    ) {
                      this.checkJson[i][z].checkPerent.push(
                        Math.round(
                          (this.checkJson[i][z].checkCount[k] /
                            parseInt(this.worksStudent[i].length)) *
                          100
                        )
                      );
                    }
                  }
                }
              }
            }
          }
          this.selectWorksStudent();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    pngToWhiteBg(file) {
      const _file = file;
      let read = new FileReader();
      read.readAsDataURL(file); // 文件转base64
      return new Promise((resolve, reject) => {
        read.onload = (e) => {
          let img = new Image();
          img.src = e.target.result;
          img.onload = async () => {
            // 生成canvas
            let canvas = document.createElement("canvas");
            let context = canvas.getContext("2d");
            // 绘制图片到canvas上
            canvas.width = img.width;
            canvas.height = img.height;

            // 在canvas绘制前填充白色背景
            context.fillStyle = "#fff";
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.drawImage(img, 0, 0);
            let base64 = canvas.toDataURL(file["type"], 1);
            let newFile = this.dataUrlToFile(base64, _file);
            resolve(newFile);
          };
        };
      });
    },
    dataUrlToFile(dataurl, file) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      // return new Blob([u8arr], { type: mime });
      return new File([new Blob([u8arr], { type: mime })], file.name, {
        type: mime,
      });
    },
    async beforeUpload1(event, type, i) {
      // this.$message.success('进入上传')
      var file = "";
      if (type == 5) {
        file = event;
      } else {
        file = event.target.files[0];
      }
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;
      _this.progress = 0;
      _this.proVisible = true;
      var b = [
        "DOC",
        "DOCX",
        "DOCM",
        "DOTM",
        "DOTX",
        "PPTX",
        "PPSX",
        "PPT",
        "PPS",
        "PPTM",
        "POTM",
        "PPAM",
        "POTX",
        "PPSM",
      ];
      var excelA = ["XLSX", "XLXB", "XLS", "XLSM"];
      var photoA = [
        "BMP",
        "GIF",
        "PNG",
        "JPGE",
        "JPG",
        "TIF",
        "PCX",
        "TGA",
        "EXIF",
        "FPX",
        "SVG",
        "APNG",
      ];
      // if (
      //   b.indexOf(
      //     file.name
      //       .split(".")
      //     [file.name.split(".").length - 1].toLocaleUpperCase()
      //   ) != -1
      // ) {
      //   if (file.size / 1024 / 1024 > 10) {
      //     this.$message.error("上传文件大于10兆,请重新选择文件！");
      //     return;
      //   }
      // } else if (
      //   excelA.indexOf(
      //     file.name
      //       .split(".")
      //     [file.name.split(".").length - 1].toLocaleUpperCase()
      //   ) != "-1"
      // ) {
      //   if (file.size / 1024 / 1024 > 5) {
      //     this.$message.error("添加成上传文件大于5兆,请重新选择文件！");
      //     return;
      //   }
      // }

      if (
        photoA.indexOf(
          file.name
            .split(".")
          [file.name.split(".").length - 1].toLocaleUpperCase()
        ) != -1 &&
        type != 4
      ) {
        // const blob = await imageConversion.compress(file, 0.8)
        file = await this.pngToWhiteBg(file);
        const blob = await imageConversion.compressAccurately(file, 256);
        // const blob = await imageConversion.compressAccurately(file, {type:file.type});
        file = new File([blob], file.name, { type: file.type });
      }


      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          // partSize: 2048 * 1024 * 1024,
          partSize: 1024 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function (evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
            _this.progress = parseInt((evt.loaded * 80) / evt.total);
          })
          .send(function (err, data) {
            _this.progress = 100;
            setTimeout(() => {
              _this.proVisible = false;
            }, 1000);
            if (err) {
              var a = _this.$refs.upload1.uploadFiles;
              a.splice(a.length - 1, a.length);
              _this.$message.error("上传失败");
            } else {
              // _this.$message.success('上传成功')
              if (type == 1) {
                _this.studyJuri[0].cover.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                });
                var b = ["PDF", "DOC", "DOCX", "PPT", "PPTX", "XLSX", "XLS"];
                var c = [
                  "AVI",
                  "NAVI",
                  "MPEG",
                  "ASF",
                  "MOV",
                  "WMV",
                  "3GP",
                  "RM",
                  "RMVB",
                  "FLV",
                  "F4V",
                  "H.264",
                  "H.265",
                  "REAL VIDEO",
                  "MKV",
                  "WebM",
                  "HDDVD",
                  "MP4",
                  "MPG",
                  "M4V",
                  "MGV",
                  "OGV",
                  "QTM",
                  "STR",
                  "AMC",
                  "DVX",
                  "EVO",
                  "DAT",
                  "OGG",
                  "OGM",
                ];
                if (
                  c.indexOf(
                    _this.studyJuri[0].cover[0].url
                      .split(".")
                    [
                      _this.studyJuri[0].cover[0].url.split(".").length - 1
                    ].toLocaleUpperCase()
                  ) != -1
                ) {
                  _this.fileType = 2;
                } else if (
                  b.indexOf(
                    _this.studyJuri[0].cover[0].url
                      .split(".")
                    [
                      _this.studyJuri[0].cover[0].url.split(".").length - 1
                    ].toLocaleUpperCase()
                  ) != -1
                ) {
                  _this.fileType = 1;
                } else {
                  _this.fileType = 0;
                }
                _this.imgChange(null, null, type);
              } else if (type == 2) {
                _this.upToolImg = data.Location;
                _this.imgChange(null, null, type);
                _this.addCourseWorks(i);
              } else if (type == 4) {
                _this.addPz("3", data.Location);
              } else if (type == 5) {
                _this.addImgDrawImG(data.Location);
              }
              _this.imgChange(null, null, type);
              console.log(data.Location);
              // _this.$message.success('上传成功'+data.Location)
            }
          });
      }
    },
    beforeUpload2(event, type) {
      var file = event.target.files[0];
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;
      _this.progress = 0;
      _this.proVisible = true;

      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function (evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
            _this.progress = parseInt((evt.loaded * 80) / evt.total);
          })
          .send(function (err, data) {
            _this.progress = 100;
            setTimeout(() => {
              _this.proVisible = false;
            }, 1000);
            if (err) {
              var a = _this.$refs.upload1.uploadFiles;
              a.splice(a.length - 1, a.length);
              _this.$message.error("上传失败");
            } else {
              if (type == 2) {
                _this.studyJuri[0].upVedio.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                });
                _this.imgChange(null, null, type);
              } else if (type == 3) {
                _this.studyJuri[0].upFile.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                });
                _this.imgChange(null, null, type);
              }
              console.log(data.Location);
            }
          });
      }
    },
    allScrell() {
      window.opener.postMessage({ allScreen: this.screenType }, "*");
    },
    nextOrpreSteps(t) {
      var b = this.chapInfoList.length - 1;
      if (t == 0) {
        if (this.courseType == 0) {
          if (this.taskCount == 0) {
            // console.log(this.navList[b].task[this.navList[b].task.length - 1].isLook);
            if (this.IsLookOpen) {
              if (
                !this.navList[b].task[this.navList[b].task.length - 1].isLook
              ) {
                if (this.courseDetail.userid != this.userid) {
                  this.$message.error("任务未解锁");
                } else {
                  this.$message.error("上一任务未解锁");
                }
                return;
              }
            }
            this.navList[this.courseType].isOpen = false;
            this.courseType = b;
            this.taskCount =
              this.chapInfoList[this.courseType].chapterInfo[0].taskJson
                .length - 1;
            this.navList[this.courseType].isOpen = true;
          } else {
            this.taskCount--;
          }
        } else {
          if (this.taskCount == 0) {
            this.navList[this.courseType].isOpen = false;
            this.courseType--;
            this.taskCount =
              this.chapInfoList[this.courseType].chapterInfo[0].taskJson
                .length - 1;
            this.navList[this.courseType].isOpen = true;
          } else {
            this.taskCount--;
          }
        }
      } else {
        if (this.courseType == b) {
          if (
            this.taskCount ==
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson.length -
            1
          ) {
            this.navList[this.courseType].isOpen = false;
            this.courseType = 0;
            this.taskCount = 0;
            this.navList[this.courseType].isOpen = true;
          } else {
            var bbb = parseInt(this.taskCount) + 1;
            if (
              !this.chapInfoList[this.courseType].chapterInfo[0].taskJson[bbb]
                .isLook &&
              this.courseDetail.userid != this.userid &&
              this.IsLookOpen
            ) {
              this.$message.error("任务未解锁");
              return;
            }
            this.taskCount++;
            if (this.IsLookOpen) {
              this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
                this.taskCount
              ].isLook = true;
              this.addCourseState(3);
            }
          }
        } else {
          if (
            this.taskCount ==
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson.length -
            1
          ) {
            var bbb = parseInt(this.courseType) + 1;
            if (
              !this.chapInfoList[bbb].chapterInfo[0].taskJson[0].isLook &&
              this.courseDetail.userid != this.userid &&
              this.IsLookOpen
            ) {
              this.$message.error("任务未解锁");
              return;
            }
            this.navList[this.courseType].isOpen = false;
            this.courseType++;
            this.taskCount = 0;
            this.navList[this.courseType].isOpen = true;
          } else {
            var bbb = parseInt(this.taskCount) + 1;
            if (
              !this.chapInfoList[this.courseType].chapterInfo[0].taskJson[bbb]
                .isLook &&
              this.courseDetail.userid != this.userid &&
              this.IsLookOpen
            ) {
              this.$message.error("任务未解锁");
              return;
            }
            this.taskCount++;
          }
          if (this.IsLookOpen) {
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              this.taskCount
            ].isLook = true;
            this.addCourseState(3);
          }
        }

        // if (
        //   this.taskCount ==
        //   this.chapInfo.chapterInfo[0].taskJson.length - 1
        // ) {
        //   this.taskCount = this.chapInfo.chapterInfo[0].taskJson.length - 1;
        // } else {
        //   this.taskCount++;
        // }
      }
      document.scrollingElement.scrollTop = 0;
      this.showType = 0;
      this.navId = this.navList[this.courseType].task[this.taskCount].id;
      // if (this.vedio[this.taskCount].length > 0) {
      //   var a =
      //     document.getElementsByClassName("box_course")[this.taskCount]
      //       .offsetHeight;
      //   document.getElementsByClassName("vedioList")[
      //     this.taskCount
      //   ].style.height = a + "px";
      //   document.getElementsByClassName("navBox")[this.taskCount].style.height =
      //     a - 40 + "px";
      // }

      this.isNoHomeWork = false;
      (this.studyJuri = [
        {
          content: "",
          cover: [],
          upVedio: [],
          upFile: [],
        },
      ]),
        (this.radio = []);
      this.isClickNav = "";
      this.selectPz();
      this.getHomeWork();
      this.getCourseDetail();
      this.$forceUpdate();
    },
    openTask(s, n, i) {
      if (this.IsLookOpen) {
        if (
          !this.chapInfoList[s].chapterInfo[0].taskJson[n].isLook &&
          this.courseDetail.userid != this.userid
        ) {
          this.$message.error("任务未解锁");
          return;
        }
        if (this.courseType == s && this.taskCount != n && n > this.taskCount) {
          if (
            !this.chapInfoList[this.courseType].chapterInfo[0].taskJson[n - 1]
              .isLook
          ) {
            this.$message.error("上一任务未解锁");
            return;
          }
        } else if (s > this.courseType) {
          if (n > 0) {
            if (!this.chapInfoList[s].chapterInfo[0].taskJson[n - 1].isLook) {
              this.$message.error("上一任务未解锁");
              return;
            }
          } else {
            if (
              !this.chapInfoList[s - 1].chapterInfo[0].taskJson[
                this.chapInfoList[s - 1].chapterInfo[0].taskJson.length - 1
              ].isLook
            ) {
              this.$message.error("上一任务未解锁");
              return;
            }
          }
        }
      }
      this.courseType = s;
      this.navId = i;
      this.taskCount = n;
      if (this.IsLookOpen) {
        this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
          this.taskCount
        ].isLook = true;
        this.addCourseState(3);
      }
      this.showType = 0;
      this.isNoHomeWork = false;
      (this.studyJuri = [
        {
          content: "",
          cover: [],
          upVedio: [],
          upFile: [],
        },
      ]),
        (this.radio = []);
      document.scrollingElement.scrollTop = 0;

      // setTimeout(() => {
      //   let a = document.getElementById(i);
      //   if (a.offsetTop - 110 == 0) {
      //     window.scrollTo(0, 0);
      //   } else {
      //     window.scrollTo(0, a.offsetTop);
      //   }
      // }, 0);
      this.selectPz();
      this.getHomeWork();
      this.getCourseDetail();
    },

    get(i) {
      this.navList[i].isOpen = !this.navList[i].isOpen;
    },
    addQuestion() {
      this.answerList.push({
        answerTitle: this.answerQ.replaceAll(/%/g, "%25"),
        answer: this.questionAnswer.replaceAll(/%/g, "%25"),
      });
      let params = [
        {
          uid: this.userid,
          cid: this.id,
          stage: this.courseType,
          task: this.taskCount,
          tool: this.toolindex,
          content: JSON.stringify(this.answerList),
          type: 3,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addCourseWorks", params)
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.answerList = [];
          this.answerDialogVisible = false;
          this.selectStudent();
          this.selectSWorks();
          this.selectSLook();
        })
        .catch((err) => {
          this.$message.error("提交失败");
          console.error(err);
        });
    },
    getCourseDetail() {
      const loading = this.$loading.service({
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector(".student_table"),
      });
      // this.navList[0].isOpen = false;
      // this.navList[this.courseType].isOpen = true;
      // this.courseType = this.courseTypeLine;
      // this.navId = this.navList[this.courseType].task[this.taskCount].id;
      let params = {
        courseId: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "selectCourseDetail", params)
        .then((res) => {
          loading.close();
          var a = JSON.parse(res.data[0][0].chapters)[this.courseType]
            .chapterInfo[0].taskJson;
          var b = [
            "AVI",
            "NAVI",
            "MPEG",
            "ASF",
            "MOV",
            "WMV",
            "3GP",
            "RM",
            "RMVB",
            "FLV",
            "F4V",
            "H.264",
            "H.265",
            "REAL VIDEO",
            "MKV",
            "WebM",
            "HDDVD",
            "MP4",
            "MPG",
            "M4V",
            "MGV",
            "OGV",
            "QTM",
            "STR",
            "AMC",
            "DVX",
            "EVO",
            "DAT",
            "OGG",
            "OGM",
          ];
          for (var i = 0; i < a.length; i++) {
            var c = a[i].chapterData;
            this.vedio[i] = [];
            this.textList[i] = [];
            this.lineList[i] = [];
            this.chapToolList[i] = [];
            this.file[i] = [];
            for (var j = 0; j < c.length; j++) {
              if (c[j].type == 7) {
                this.chapToolList[i].push(c[j]);
              } else if (c[j].type == 8) {
                this.lineList[i].push(c[j]);
              } else if (c[j].type == 6) {
                this.textList[i].push(c[j]);
              } else {
                if (
                  b.indexOf(
                    c[j].url
                      .split(".")
                    [c[j].url.split(".").length - 1].toLocaleUpperCase()
                  ) != -1
                ) {
                  this.vedio[i].push(c[j]);
                } else {
                  this.file[i].push(c[j]);
                }
              }
            }
            var d = JSON.parse(JSON.stringify(this.playerOptions));
            d.sources[0].src =
              this.vedio[i].length > 0 ? this.vedio[i][0].url : this.mr;
            this.playerO[i] = d;
          }
          this.courseDetail = res.data[0][0];
          this.evalua = res.data[0][0].evaId;
          this.chapInfo = JSON.parse(this.courseDetail.chapters)[
            this.courseType
          ];
          this.chapInfoList = JSON.parse(this.courseDetail.chapters);
          // if (this.navList.length == 0) {
          //   this.navList = [];
          //   for (var l = 0; l < this.chapInfoList.length; l++) {
          //     var q = this.chapInfoList[l].dyName;
          //     var w = this.chapInfoList[l].chapterInfo[0].taskJson;
          //     var e;
          //     this.navList.push({
          //       dyName: q,
          //       isOpen: l === 0 ? true : false,
          //       task: [],
          //     });
          //     for (var r = 0; r < w.length; r++) {
          //       e = w[r].task;
          //       this.navList[l].task.push({ taskName: e, id: l + "-" + r });
          //       this.navId = this.navId ? this.navId : l + "-" + r;
          //     }
          //   }
          // }
          // this.navList[0].isOpen = false;
          // this.navList[this.courseType].isOpen = true;
          // this.navId = this.navList[this.courseType].task[this.taskCount].id;
          for (var l = 0; l < this.chapInfoList.length; l++) {
            var w = this.chapInfoList[l].chapterInfo[0].taskJson;
            for (var m = 0; m < w.length; m++) {
              w[m].id = l + "-" + m;
            }
          }
          if (
            !this.vedio[this.taskCount][0] ||
            this.vedio[this.taskCount][0].url == ""
          ) {
            if (
              this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
                this.taskCount
              ].chapterData.length > 0
            ) {
              // if (
              //   this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              //     this.taskCount
              //   ].chapterData[0].type != 8
              // ) {
              let _url =
                this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
                  this.taskCount
                ].chapterData[0].url;
              if (
                this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
                  this.taskCount
                ].chapterData[0].type == 8
              ) {
                this.showType = 2;
                if (
                  _url.indexOf("https://") == -1 &&
                  _url.indexOf("http://") == -1
                ) {
                  _url = "https://" + _url;
                }
                this.pptImgUrl1 = _url;
                this.isClickNav = "line0";
              } else if (
                this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
                  this.taskCount
                ].chapterData[0].type == 3
              ) {
                if (
                  _url
                    .split(".")
                  [_url.split(".").length - 1].toLocaleUpperCase() == "PDF"
                ) {
                  this.showType = 3;
                  this.pptImgUrl1 = _url;
                  this.isClickNav = "word0";
                } else if (
                  this.isAssetTypeAnImage(
                    _url
                      .split(".")
                    [_url.split(".").length - 1].toLocaleLowerCase()
                  )
                ) {
                  this.showType = 4;
                  this.pptImgUrl1 = _url;
                  this.isClickNav = "word0";
                } else {
                  this.showType = 2;
                  this.pptImgUrl1 =
                    "https://view.officeapps.live.com/op/view.aspx?src=" + _url;
                  this.isClickNav = "word0";
                }
              } else if (
                this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
                  this.taskCount
                ].chapterData[0].type == 6
              ) {
                this.showType = 1;
                this.text = this.textList[this.taskCount][0];
                this.isClickNav = "text0";
              }
              // }
              //  else {
              //   for (
              //     var y = 0;
              //     y <
              //     this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              //       this.taskCount
              //     ].chapterData.length;
              //     y++
              //   ) {
              //     if (
              //       this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              //         this.taskCount
              //       ].chapterData[y].type != 8
              //     ) {
              //       if (
              //         this.chapInfoList[this.courseType].chapterInfo[0]
              //           .taskJson[this.taskCount].chapterData[y].type == 3
              //       ) {
              //         let _url =
              //           this.chapInfoList[this.courseType].chapterInfo[0]
              //             .taskJson[this.taskCount].chapterData[y].url;
              //         if (
              //           _url
              //             .split(".")
              //             [_url.split(".").length - 1].toLocaleUpperCase() ==
              //           "PDF"
              //         ) {
              //           this.showType = 3;
              //           this.pptImgUrl1 = _url;
              //         } else if (
              //           this.isAssetTypeAnImage(
              //             _url
              //               .split(".")
              //               [_url.split(".").length - 1].toLocaleLowerCase()
              //           )
              //         ) {
              //           this.showType = 4;
              //           this.pptImgUrl1 = _url;
              //         } else {
              //           this.showType = 2;
              //           this.pptImgUrl1 =
              //             "https://view.officeapps.live.com/op/view.aspx?src=" +
              //             _url;
              //         }
              //       } else if (
              //         this.chapInfoList[this.courseType].chapterInfo[0]
              //           .taskJson[this.taskCount].chapterData[y].type == 6
              //       ) {
              //         this.showType = 1;
              //         this.text = this.textList[this.taskCount][0];
              //       }
              //     } else {
              //       this.showType = 2;
              //       this.pptImgUrl1 =
              //         "https://view.officeapps.live.com/op/view.aspx?src=" +
              //         _url;
              //     }
              //   }
              // }
            }
          } else {
            this.isClickNav = "video0";
          }
          setTimeout(() => {
            this.checkEva();
          }, 500);
          this.selectStudent();
          this.selectSWorks();
          this.selectSLook();
          let _this = this;
          if (_this.timer) {
            clearInterval(_this.timer);
            _this.timer = null;
          }
          _this.timer = setInterval(function () {
            _this.selectSWorks();
            _this.selectStudent();
            _this.selectSLook();
            if (_this.tType == 4) {
              _this.selectPz();
            }
          }, 5000);
          _this.$nextTick(function () {
            setTimeout(() => {
              var a =
                document.getElementsByClassName("box_course")[0].offsetHeight;
              document.getElementsByClassName("vedioList")[0].style.height =
                a + "px";
              document.getElementsByClassName("navBox")[0].style.height =
                a - 40 + "px";
              if (_this.vedio[_this.taskCount].length > 0) {
                _this.vedioTime = [];
                for (var i = 0; i < _this.vedio[_this.taskCount].length; i++) {
                  _this.vedioTime[i] = document.getElementsByClassName(
                    "vjs-duration-display"
                  )[i].textContent;
                }
              }
            }, 500);
          });
        })
        .catch((err) => {
          loading.close();
          console.error(err);
        });
    },
    addPz(type, content) {
      if (type == "1" && this.pzConText == "") {
        this.$message.error("批注不能为空！");
        return;
      }
      let params = [
        {
          cid: this.id,
          uid: this.userid,
          s: this.courseType,
          t: this.taskCount,
          c: type == "1" ? this.pzConText.replaceAll(/%/g, "%25") : content,
          type: type,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addPz2", params)
        .then((res) => {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.pzConText = "";
          this.addPzDialog = false;
          this.selectPz();
        })
        .catch((err) => {
          this.$message.error("添加失败");
          console.error(err);
        });
    },
    deletePz(id) {
      this.$confirm("确定删除此批注吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = [
            {
              id: id,
            },
          ];
          this.ajax
            .post(this.$store.state.api + "deletePz", params)
            .then((res) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.selectPz();
            })
            .catch((err) => {
              this.$message.error("网络异常");
              console.error(err);
            });
        })
        .catch(() => { });
    },
    selectPz() {
      let params = {
        cid: this.id,
        s: this.courseType,
        t: this.taskCount,
      };
      this.ajax
        .get(this.$store.state.api + "selectPzList", params)
        .then((res) => {
          this.pzList = res.data[0];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateSLook() {
      let params = {
        sopen: this.sIsOpen == false ? 1 : 2,
        cid: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "updateCourseSLook", params)
        .then((res) => {
          if (this.sIsOpen == true) {
            this.$message({
              message: "权限设置成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "权限关闭成功",
              type: "success",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateLookOpen() {
      let params = [
        {
          sopen: this.IsLookOpen == false ? 1 : 2,
          cid: this.id,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "updateCourseLookOpen", params)
        .then((res) => {
          if (this.IsLookOpen == true) {
            // if (this.courseType != 0 && this.taskCount != 0) {
            //   this.openTask(0, 0, "0-0");
            // }
            this.$message({
              message: "权限设置成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "权限关闭成功",
              type: "success",
            });
          }
          this.getCourseState(2);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectSLook() {
      let params = {
        cid: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "selectCourseSLook", params)
        .then((res) => {
          this.sIsOpen = res.data[0][0].sopen == 1 ? false : true;
          this.IsLookOpen = res.data[0][0].look == 1 ? false : true;
          if (!this.IsLookOpen) {
            this.setNavList();
          } else {
            this.getCourseState(1);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setNavList() {
      if (this.navList.length == 0) {
        this.navList = [];
        for (var l = 0; l < this.chapInfoList.length; l++) {
          var q = this.chapInfoList[l].dyName;
          var w = this.chapInfoList[l].chapterInfo[0].taskJson;
          var e;
          this.navList.push({
            dyName: q,
            isOpen: l === 0 ? true : false,
            task: [],
          });
          for (var r = 0; r < w.length; r++) {
            e = w[r].task;
            this.navList[l].task.push({
              taskName: e,
              id: l + "-" + r,
              isLook: w[r].isLook,
            });
            // this.navId = this.navId ? this.navId : l + "-" + r;
            // this.navId = l + "-" + r;
          }
        }
        this.navList[0].isOpen = false;
        this.navList[this.courseType].isOpen = true;
        this.navId = this.navList[this.courseType].task[this.taskCount].id;
      } else {
        this.setNavList2();
      }
    },
    setNavList2() {
      for (var l = 0; l < this.chapInfoList.length; l++) {
        var w = this.chapInfoList[l].chapterInfo[0].taskJson;
        for (var r = 0; r < w.length; r++) {
          this.navList[l].task[r].isLook = w[r].isLook;
        }
      }
      if (
        this.IsLookOpen &&
        !this.navList[this.courseType].task[this.taskCount].isLook
      ) {
        this.openTask(0, 0, "0-0");
      }
      this.$forceUpdate();
    },
    getCourseState(type) {
      let params = {
        cid: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "getCourseState", params)
        .then((res) => {
          if (res.data[0].length > 0 && this.IsLookOpen && type == 1) {
            this.chapInfoList = JSON.parse(res.data[0][0].state);
            this.setNavList();
            this.$forceUpdate();
          } else if (res.data[0].length > 0 && this.IsLookOpen && type == 2) {
            this.addCourseState(2);
          } else {
            this.addCourseState(1);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    addCourseState(type) {
      let _state = this.chapInfoList;
      if (type == 1 || type == 2) {
        for (var i = 0; i < _state.length; i++) {
          let el = _state[i].chapterInfo[0].taskJson;
          for (var j = 0; j < el.length; j++) {
            // if (i == 0 && j == 0) {
            //   el[j].isLook = true;
            // } else {
            //   el[j].isLook = false;
            // }
            if (
              this.courseType > i ||
              (this.courseType == i && this.taskCount + 1 > j)
            ) {
              el[j].isLook = true;
            } else {
              el[j].isLook = false;
            }
          }
        }
      }
      let params = [
        {
          cid: this.id,
          state: JSON.stringify(_state).replaceAll(/%/g, "%25"),
        },
      ];
      this.ajax
        .post(
          this.$store.state.api +
          (type == 1 ? "addCourseState" : "updateCourseSate"),
          params
        )
        .then((res) => {
          if (this.IsLookOpen) {
            this.setNavList();
          }
          if (type == 3 && type == 2) {
            this.getCourseState(1);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getHomeWork() {
      let params = {
        cid: this.id,
        stage: this.courseType,
        task: this.taskCount,
        uid: this.userid,
      };
      this.ajax
        .get(this.$store.state.api + "selectWork", params)
        .then((res) => {
          if (res.data[0].length > 0) {
            this.studyJuri = JSON.parse(res.data[0][0].content);
            this.isNoHomeWork = true;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    isAssetTypeAnImage(ext) {
      return (
        [
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "gif",
          "webp",
          "psd",
          "svg",
          "tiff",
        ].indexOf(ext) !== -1
      );
    },
    switchVideo(media) {
      this.playerO = {};
      this.playerOptions.poster = "";
      this.playerOptions.sources[0].src = media;
      this.playerO = this.playerOptions;
    },
    onPlayerPlay() { },
    lookVedio(u, i) {
      this.isClickNav = "";
      // this.playerOptions.sources[0].src = u;
      var d = JSON.parse(JSON.stringify(this.playerOptions));
      d.sources[0].src = u;
      this.playerO[this.taskCount] = d;
      this.showType = 0;
      this.isClickNav = "video" + i;
      this.$forceUpdate();
    },
    lookText(i, t) {
      this.isClickNav = "";
      this.text = this.textList[i][t];
      // this.dialogVisible1 = true;
      this.showType = 1;
      this.isClickNav = "text" + t;
    },
    lookTools(i, t) {
      this.chapTools = this.chapToolList[i][t];
      this.dialogVisible2 = true;
    },
    openFile(f) {
      this.pptImgUrl = "";
      var a = ["PPT", "PPTX", "XLSX", "XLS", "DOC", "DOCX"];
      if (
        a.indexOf(f.split(".")[f.split(".").length - 1].toLocaleUpperCase()) !=
        -1
      ) {
        this.pptImgUrl =
          "https://view.officeapps.live.com/op/view.aspx?src=" + f;
        this.showPDF = false;
        this.dialogVisible3 = true;
      } else if (
        f.split(".")[f.split(".").length - 1].toLocaleUpperCase() == "PDF"
      ) {
        this.pptImgUrl = f;
        this.showPDF = true;
        this.dialogVisible3 = true;
      }
    },
    doUrl(url, i) {
      this.isClickNav = "";
      this.pptImgUrl1 = "";
      this.showType = 2;
      if (url.indexOf("https://") == -1 && url.indexOf("http://") == -1) {
        url = "https://" + url;
      }
      this.pptImgUrl1 = url;
      this.isClickNav = "line" + i;
    },
    downFile(f, i) {
      this.isClickNav = "";
      this.pptImgUrl1 = "";
      var a = ["PPT", "PPTX", "XLSX", "XLS", "DOC", "DOCX"]; //"PDF",
      if (
        a.indexOf(
          f.url.split(".")[f.url.split(".").length - 1].toLocaleUpperCase()
        ) != -1
      ) {
        this.pptImgUrl1 =
          "https://view.officeapps.live.com/op/view.aspx?src=" + f.url;
        // this.dialogVisible3 = true;
        this.showType = 2;
      } else if (
        this.isAssetTypeAnImage(
          f.url.split(".")[f.url.split(".").length - 1].toLocaleLowerCase()
        )
      ) {
        this.showType = 4;
        this.pptImgUrl1 = f.url;
      } else if (
        f.url.split(".")[f.url.split(".").length - 1].toLocaleUpperCase() ==
        "PDF"
      ) {
        this.pptImgUrl1 = f.url;
        // this.dialogVisible3 = true;
        this.showType = 3;
      } else {
        window.open(this.file[i].url);
      }
      this.isClickNav = "word" + i;
    },
    downFileList(i) {
      window.open(this.noImgList[i].url);
    },
    openAddWork() {
      this.dialogVisible = true;
    },
    addBzWorks() {
      let params = [
        {
          uid: this.userid,
          cid: this.id,
          stage: this.courseType,
          task: this.taskCount,
          tool: this.toolindex,
          content: JSON.stringify(this.eScore),
          type: 6,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addCourseWorks", params)
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.eScore = { eBzText: "", eStar: [] };
          this.studentEvalDialogVisible = false;
          this.selectSWorks();
        })
        .catch((err) => {
          this.$message.error("提交失败");
          console.error(err);
        });
    },
    addStudentAsk() {
      for (var i = 0; i < this.radio.length; i++) {
        if (this.radio[i] !== 0 && !this.radio[i]) {
          this.$message.error("请选择选项");
          return;
        }
      }
      this.askList.push({ askJson: this.askJson, anwer: this.radio.join(",") });
      let params = [
        {
          uid: this.userid,
          cid: this.id,
          stage: this.courseType,
          task: this.taskCount,
          tool: this.toolindex,
          content: JSON.stringify(this.askList).replaceAll(/%/g, "%25"),
          type: 2,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addCourseWorks", params)
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.askList = [];
          this.dialogVisible5 = false;
          this.selectStudent();
          this.selectSWorks();
          this.selectSLook();
        })
        .catch((err) => {
          this.$message.error("提交失败");
          console.error(err);
        });
    },
    addStudentTest() {
      for (var i = 0; i < this.radio.length; i++) {
        if (
          (this.radio[i] instanceof Array && !this.radio[i].length) ||
          (this.radio[i] !== 0 && !this.radio[i])
        ) {
          this.$message.error("请选择选项");
          return;
        }
      }
      this.askList.push({ testJson: this.testJson, anwer: this.radio });
      let params = [
        {
          uid: this.userid,
          cid: this.id,
          stage: this.courseType,
          task: this.taskCount,
          tool: this.toolindex,
          content: JSON.stringify(this.askList).replaceAll(/%/g, "%25"),
          type: 8,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "addCourseWorks", params)
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.askList = [];
          this.dialogVisibleChoice = false;
          this.selectStudent();
          this.selectSWorks();
          this.selectSLook();
        })
        .catch((err) => {
          this.$message.error("提交失败");
          console.error(err);
        });
    },
    addWork() {
      if (this.studyJuri[0].content == "") {
        this.$message.error("请将信息填写完整");
        return;
      } else if (this.studyJuri[0].cover.length == 0) {
        this.$message.error("请将信息填写完整");
        return;
      } else if (this.studyJuri[0].upVedio.length == 0) {
        this.$message.error("请将信息填写完整");
        return;
      }
      if (this.isNoHomeWork) {
        this.$confirm(
          "您已经提交了该作业了，如果您再提交将覆盖上次提交的作业！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            let params = [
              {
                uid: this.userid,
                cid: this.id,
                stage: this.courseType,
                task: this.taskCount,
                content: JSON.stringify(this.studyJuri),
              },
            ];
            this.ajax
              .post(this.$store.state.api + "addWorks", params)
              .then((res) => {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.isNoHomeWork = true;
                this.dialogVisible = false;
              })
              .catch((err) => {
                this.$message.error("提交失败");
                console.error(err);
              });
          })
          .catch(() => { });
      } else {
        let params = [
          {
            uid: this.userid,
            cid: this.id,
            stage: this.courseType,
            task: this.taskCount,
            content: JSON.stringify(this.studyJuri),
          },
        ];
        this.ajax
          .post(this.$store.state.api + "addWorks", params)
          .then((res) => {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.isNoHomeWork = true;
            this.dialogVisible = false;
          })
          .catch((err) => {
            this.$message.error("提交失败");
            console.error(err);
          });
      }
    },
    selectCount() {
      let params = {
        cid: this.id,
        chid: this.courseType,
        uid: this.userid,
      };
      this.ajax
        .get(this.$store.state.api + "selectToolsCount", params)
        .then((res) => {
          for (var i = 0; i < res.data[0].length; i++) {
            if (res.data[0][i].tools == 1) {
              this.wbCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 2) {
              this.wordCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 3) {
              this.mindCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 4) {
              this.askCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 6) {
              this.noteCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 7) {
              this.mindNetWorkCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 8) {
              this.libraryCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 16) {
              this.workCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 10) {
              this.timeCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 15) {
              this.answerCount = res.data[0][i].count;
            } else if (res.data[0][i].tools == 18) {
              this.trainCount = res.data[0][i].count;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    openTools(t, i, index, c, sName) {
      var z = JSON.parse(c);
      this.noteName = sName;
      if (t == 4) {
        this.radio = [];
        this.isAnswer = false;
        for (var i = 0; i < z.length; i++) {
          let a = z[i];
          let b = a.anwer.split(",");
          let d = [];
          for (var j = 0; j < b.length; j++) {
            d.push(parseInt(b[j]));
          }
          this.radio = d;
          this.askJson = a.askJson;
        }
        this.isAnswer = true;
        this.dialogVisible5 = true;
      } else if (t == 45) {
        this.radio = [];
        this.isAnswer = false;
        let b = z[0].anwer;
        this.radio = b;
        this.testJson = z[0].testJson;
        this.isAnswer = true;
        this.dialogVisibleChoice = true;
      }
      //  else if (t == 15) {
      //   this.answerQ = "";
      //   this.questionAnswer = "";
      //   this.answerQ = z[0].answerTitle;
      //   this.questionAnswer = z[0].answer;
      //   this.answerDialogVisible = true;
      // }
    },

    fastText(p, t) {
      if (t == 1) {
        this.commentText += p;
      } else {
        this.eScore.eBzText += p;
      }
    },
    addTools(t, i, index) {
      var a = 0;
      // this.taskCount = index;
      this.toolindex = i;
      if (t == 1) {
        if (this.wbCount > 0) {
          this.updateCount(this.wbCount, t);
        } else {
          this.wbCount++;
          a = this.wbCount;
          this.toolsCount(a, t);
        }
        window.opener.postMessage(
          {
            tools: "1",
            cid: this.id,
            stage: this.courseType,
            task: this.taskCount,
            tool: i,
          },
          "*"
        );
      } else if (t == 2) {
        if (this.wordCount > 0) {
          this.updateCount(this.wordCount, t);
        } else {
          this.wordCount++;
          a = this.wordCount;
          this.toolsCount(a, t);
        }
        window.opener.postMessage({ tools: "2" }, "*");
      } else if (t == 3) {
        if (this.mindCount > 0) {
          this.updateCount(this.mindCount, t);
        } else {
          this.mindCount++;
          a = this.mindCount;
          this.toolsCount(a, t);
        }
        window.opener.postMessage(
          {
            tools: "3",
            cid: this.id,
            stage: this.courseType,
            task: this.taskCount,
            tool: i,
          },
          "*"
        );
      } else if (t == 4) {
        this.radio = [];
        this.noteName = "";
        this.isAnswer = false;
        if (this.askCount > 0) {
          this.updateCount(this.askCount, t);
        } else {
          this.askCount++;
          a = this.askCount;
          this.toolsCount(a, t);
        }
        if (!this.dialogVisible2) {
          this.askJson.askJson =
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              index
            ].toolChoose[i].askJson;
          this.askJson.askTitle =
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              index
            ].toolChoose[i].askTitle;
          this.askJson.askCount =
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              index
            ].toolChoose[i].askCount;
        } else {
          this.askJson.askJson = this.chapTools.askJson.askJson;
          this.askJson.askTitle = this.chapTools.askJson.askTitle;
          this.askJson.askCount = this.chapTools.askJson.askCount;
        }
        this.dialogVisible5 = true;

        // window.opener.postMessage({ tools: "4" }, "*");
      } else if (t == 45) {
        this.noteName = "";
        this.radio = [];
        this.isAnswer = false;
        if (this.askCount > 0) {
          this.updateCount(this.askCount, t);
        } else {
          this.askCount++;
          a = this.askCount;
          this.toolsCount(a, t);
        }
        this.testJson =
          this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
            index
          ].toolChoose[i].testJson;
        for (var k = 0; k < this.testJson.testJson.length; k++) {
          if (this.testJson.testJson[k].type == "2") {
            this.radio.push([]);
          } else {
            this.radio.push("");
          }
        }

        this.dialogVisibleChoice = true;

        // window.opener.postMessage({ tools: "4" }, "*");
      } else if (t == 5) {
        if (this.scoreCount > 0) {
          this.updateCount(this.scoreCount, t);
        } else {
          this.scoreCount++;
          a = this.scoreCount;
          this.toolsCount(a, t);
        }
        this.dialogVisible4 = true;
        // window.opener.postMessage({ tools: "5" }, "*");
      } else if (t == 6) {
        if (this.noteCount > 0) {
          this.updateCount(this.noteCount, t);
        } else {
          this.noteCount++;
          a = this.noteCount;
          this.toolsCount(a, t);
        }
        window.opener.postMessage(
          {
            tools: "6",
            cid: this.id,
            stage: this.courseType,
            task: this.taskCount,
            tool: i,
          },
          "*"
        );
      } else if (t == 7) {
        if (this.mindNetWorkCount > 0) {
          this.updateCount(this.mindNetWorkCount, t);
        } else {
          this.mindNetWorkCount++;
          a = this.mindNetWorkCount;
          this.toolsCount(a, t);
        }
        window.opener.postMessage(
          {
            tools: "7",
            cid: this.id,
            stage: this.courseType,
            task: this.taskCount,
            tool: i,
          },
          "*"
        );
      } else if (t == 16) {
        if (this.workCount > 0) {
          this.updateCount(this.workCount, t);
        } else {
          this.workCount++;
          a = this.workCount;
          this.toolsCount(a, t);
        }
        this.dialogVisible = true;
      } else if (t == 8) {
        if (this.libraryCount > 0) {
          this.updateCount(this.libraryCount, t);
        } else {
          this.libraryCount++;
          a = this.libraryCount;
          this.toolsCount(a, t);
        }
        window.opener.postMessage({ tools: "8" }, "*");
      } else if (t == 17) {
        if (this.libraryCount > 0) {
          this.updateCount(this.libraryCount, t);
        } else {
          this.libraryCount++;
          a = this.libraryCount;
          this.toolsCount(a, t);
        }
        window.opener.postMessage({ tools: "17" }, "*");
      } else if (t == 18) {
        if (this.trainCount > 0) {
          this.updateCount(this.trainCount, t);
        } else {
          this.trainCount++;
          a = this.trainCount;
          this.toolsCount(a, t);
        }
        window.opener.postMessage({ tools: "18" }, "*");
      } else if (t == 10) {
        if (this.timeCount > 0) {
          this.updateCount(this.timeCount, t);
        } else {
          this.timeCount++;
          a = this.timeCount;
          this.toolsCount(a, t);
        }
        this.timeDialogVisible = true;
      } else if (t == 15) {
        this.answerQ = "";
        this.questionAnswer = "";
        if (this.answerCount > 0) {
          this.updateCount(this.answerCount, t);
        } else {
          this.answerCount++;
          a = this.answerCount;
          this.toolsCount(a, t);
        }
        this.answerQ = this.chapInfoList[this.courseType].chapterInfo[0]
          .taskJson[index].toolChoose[i].answerQ
          ? this.chapInfoList[this.courseType].chapterInfo[0].taskJson[index]
            .toolChoose[i].answerQ
          : "";
        this.answerDialogVisible = true;
      } else if (t == 21) {
        window.opener.postMessage({ tools: "21" }, "*");
      } else if (t == 22) {
        window.opener.postMessage({ tools: "22" }, "*");
      } else if (t == 23) {
        window.opener.postMessage({ tools: "23" }, "*");
      } else if (t == 24) {
        window.opener.postMessage({ tools: "24" }, "*");
      } else if (t == 25) {
        window.opener.postMessage({ tools: "25" }, "*");
      } else if (t == 31) {
        window.opener.postMessage({ tools: "31" }, "*");
      } else if (t == 28) {
        window.opener.postMessage({ tools: "28" }, "*");
      } else if (t == 37) {
        window.opener.postMessage({ tools: "37" }, "*");
      } else if (t == 38) {
        window.opener.postMessage({ tools: "38" }, "*");
      } else if (t == 39) {
        window.opener.postMessage({ tools: "39" }, "*");
      } else if (t == 32) {
        window.opener.postMessage({ tools: "32" }, "*");
      } else if (t == 26) {
        window.opener.postMessage(
          {
            tools: "26",
            cid: this.id,
            stage: this.courseType,
            task: this.taskCount,
            tool: i,
          },
          "*"
        );
      } else if (t == 40) {
        if (this.evalCount > 0) {
          this.updateCount(this.evalCount, t);
        } else {
          this.evalCount++;
          a = this.evalCount;
          this.toolsCount(a, t);
        }
        this.eScore = { eBzText: "", eStar: [] };
        if (this.worksStudent[i].length) {
          for (var k = 0; k < this.worksStudent[i].length; k++) {
            if (this.userid == this.worksStudent[i][k].userid) {
              this.eScore = JSON.parse(this.worksStudent[i][k].works);
              this.rateJson =
                this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
                  index
                ].toolChoose[i].rateJson;
              break;
            } else {
              this.rateJson =
                this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
                  index
                ].toolChoose[i].rateJson;
            }
          }
        } else {
          this.rateJson =
            this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
              index
            ].toolChoose[i].rateJson;
        }

        this.isStar = false;
        this.studentEvalDialogVisible = true;
      } else if (t == 41) {
        this.selectJson = this.chapInfoList[this.courseType].chapterInfo[0]
          .taskJson[index].toolChoose[i].selectJson
          ? JSON.parse(
            JSON.stringify(
              this.chapInfoList[this.courseType].chapterInfo[0].taskJson[
                index
              ].toolChoose[i].selectJson
            )
          )
          : { url: "", select: [], answer: [] };
        if (this.worksStudent[i].length) {
          for (var k = 0; k < this.worksStudent[i].length; k++) {
            if (this.userid == this.worksStudent[i][k].userid) {
              var a = this.worksStudent[i][k].works.split(",");
              for (var ki = 0; ki < a.length; ki++) {
                a[ki] = parseInt(a[ki]);
              }
              this.selectAnswer = {
                answer: a,
                stu: this.worksStudent[i][k].sName,
              };
              break;
            } else {
              this.selectAnswer = { answer: [], stu: "" };
            }
          }
        } else {
          this.selectAnswer = { answer: [], stu: "" };
        }
        this.isSelect = false;
        this.dialogVisibleSelect = true;
      } else if (t == 44) {
        window.opener.postMessage({ tools: "44" }, "*");
      }
    },
    toolsCount(a, t) {
      let params = {
        cid: this.id,
        chid: this.courseType,
        uid: this.userid,
        tid: t,
        count: a,
      };
      this.ajax
        .get(this.$store.state.api + "insertToolsCount", params)
        .then((res) => {
          this.selectCount();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateCount(c, t) {
      c++;
      let params = {
        cid: this.id,
        chid: this.courseType,
        uid: this.userid,
        tid: t,
        count: c,
      };
      this.ajax
        .get(this.$store.state.api + "updateToolsCount", params)
        .then((res) => {
          this.selectCount();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    checkEva() {
      if (this.evalua != "") {
        for (var i = 0; i < this.evaJuri.length; i++) {
          if (this.evalua == this.evaJuri[i].id) {
            this.eTitle = this.evaJuri[i].title;
            this.eJson = JSON.parse(this.evaJuri[i].content);
          }
        }
        this.$forceUpdate();
        setTimeout(() => {
          this.setMindData();
        }, 0);
      }
    },
    selectEva() {
      let params = {
        oid: this.oid,
      };
      this.ajax
        .get(this.$store.state.api + "selectAllEvaluation", params)
        .then((res) => {
          this.evaJuri = res.data[0];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setMindData() {
      this.data.data = [];
      this.data.data.push({ id: "root", isroot: true, topic: this.eTitle });
      let _eJson = Object.keys(this.eJson);
      let _e = this.eJson;
      for (let i = 0; i < _eJson.length; i++) {
        let element = _e[_eJson[i]];
        this.data.data.push({
          id: element.id,
          parentid: "root",
          topic: element.name,
        });
        let _eJsonc = Object.keys(element.child);
        let _e2 = element.child;
        for (let j = 0; j < _eJsonc.length; j++) {
          let _ec = _e2[_eJsonc[j]];
          this.data.data.push({
            id: _ec.id,
            parentid: element.id,
            topic: _ec.name,
          });
          let _eJsonz = Object.keys(_ec.child);
          let _e3 = _ec.child;
          for (let z = 0; z < _eJsonz.length; z++) {
            let _ez = _e3[_eJsonz[z]];
            this.data.data.push({
              id: _ez.id,
              parentid: _ec.id,
              topic: _ez.name,
            });
          }
        }
      }
      this.$forceUpdate();
    },
    checkFileFull(type, url) {
      this.fullDialogVisible = true;
      this.fulltype = type;
      this.fullUrl = url;
    },
    downloadFile(url) {
      let _url = "";
      if (
        url.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
      ) {
        _url = url.split(
          "https://view.officeapps.live.com/op/view.aspx?src="
        )[1];
      } else {
        _url = url;
      }
      const x = new XMLHttpRequest();
      x.open("GET", _url, true);
      x.responseType = "blob";
      x.onload = function (e) {
        // const url = window.URL.createObjectURL(x.response);
        // const a = document.createElement("a");
        // a.href = url;
        // a.target = "_blank";
        // a.download = url;
        // a.click();
        // a.remove();
        let content = x.response;
        let elink = document.createElement("a");
        elink.download = decodeURI(
          _url.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1]
        );
        elink.style.display = "none";
        let blob = new Blob([content]);
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      };
      x.send();
    },
    openLine(url) {
      window.open(url);
    },
    resize() {
      if (document.getElementsByClassName("box_course").length) {
        var a = document.getElementsByClassName("box_course")[0].offsetHeight;
        document.getElementsByClassName("vedioList")[0].style.height = a + "px";
        document.getElementsByClassName("navBox")[0].style.height =
          a - 40 + "px";
      }
      this.Stbodywidth =
        document.getElementsByClassName("student_body").length &&
        document.getElementsByClassName("student_body")[0].offsetWidth;
    },
    closeDraw() {
      this.bg = null;
      this.drawShow = false;
    },
    showPicturePaint(url) {
      let params = {
        img: url,
      };
      this.ajax
        .get(this.$store.state.api + "imgToBase64", params)
        .then((res) => {
          console.log(res);
          this.drawShow = true;
          this.bg = res.data[0].img;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    addImgDraw(base64) {
      let file = { name: "批注图.png" };
      let img = this.dataUrlToFile(base64, file);
      this.beforeUpload1(img, 5);
    },
    addImgDrawImG(url) {
      // console.log(url);
      let params = [
        {
          wid: this.commentDetail.wid,
          img: url,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "updateCourseWorks", params)
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.drawShow = false;
          this.bg = "";
          this.selectSWorks();
          this.selectStudent();
        })
        .catch((err) => {
          this.$message.error("提交失败");
          console.error(err);
        });
    },
    deletePicturePaint() {
      this.$confirm("确定删除此批注吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = [
            {
              wid: this.commentDetail.wid,
              img: '',
            },
          ];
          this.ajax
            .post(this.$store.state.api + "updateCourseWorks", params)
            .then((res) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.selectSWorks();
              this.selectStudent();
            })
            .catch((err) => {
              this.$message.error("删除失败");
              console.error(err);
            });
        })
        .catch(() => { });
    },
    getAudioVideo(constraintsData) {
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先，如果有getUserMedia的话，就获得它
          var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
          // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
          if (!getUserMedia) {
            return Promise.reject({ code: 404 });
          }

          // 否则，为老的navigator.getUserMedia方法包裹一个Promise

          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        }
      }
      return navigator.mediaDevices.getUserMedia(constraintsData)
    },
    /**
     * 开始录制
     */
    startRecording(callback) {
      const _function = (screenStream) => {
        this.addStreamStopListener(screenStream, () => {
          console.log("流停止监听");
          this.stopRecording();
          this.$emit("streamStop", {})
          // this.stopRecording();
        });
        var options = {
          type: 'video',
          mimeType: 'video/webm',
          disableLogs: false,
          getNativeBlob: false, // enable it for longer recordings
          ignoreMutedMedia: false
        };
        // this.video.srcObject = screenStream;
        this.recorder = RecordRTC(screenStream, options);
        this.recorder.startRecording();
        this.recorder.screen = screenStream;
        this.videoStart = true;
        // callback(true);
      }

      this.getAudioVideo({ audio: true }).then(res => {
        this.captureScreen(_function, true);
        console.log('已点击允许,开启成功');
      }).catch(err => {
        // 	console.log('浏览器不支持，请更换浏览器')
        // } else {
        this.captureScreen(_function, false);
        console.log('请检查是否存在麦克风')
      })
    },
    /**
     * 停止录制
     */
    stopRecording(callback) {
      this.recorder.stopRecording(() => {
        // this.video.src = this.video.srcObject = null;
        // this.video.src = URL.createObjectURL(this.recorder.getBlob());
        const url = URL.createObjectURL(this.recorder.getBlob());
        const a = document.createElement("a");//this.fileName+
        let videoFile = new File([this.recorder.getBlob()], this.courseDetail.title + "录屏.mp4", {
          type: 'video/mp4'
        })
        let downloadUrl = URL.createObjectURL(videoFile);
        document.body.appendChild(a);
        a.style.display = "none";
        a.href = url;
        a.download = this.courseDetail.title + "录屏.mp4";//this.fileName + 
        a.click();
        this.recorder.screen.stop();
        this.recorder.destroy();
        this.recorder = null;
        this.videoStart = false;
        // callback(false);
      });
    },
    //初始化
    captureScreen(callback, type) {
      if (navigator.getDisplayMedia) {
        //录制结束,文件下载
        navigator.getDisplayMedia({
          video: true
        }).then(screenStream => {
          if (type) {
            navigator.mediaDevices.getUserMedia({ audio: true }).then((mic) => {
              screenStream.addTrack(mic.getTracks()[0]);
              callback(screenStream);
            });
          } else {
            callback(screenStream);
          }
        }).catch(function (error) {
          console.log('error', error);
        });
      } else if (navigator.mediaDevices.getDisplayMedia) {
        navigator.mediaDevices.getDisplayMedia({
          video: true
        }).then(screenStream => {
          if (type) {
            navigator.mediaDevices.getUserMedia({ audio: true }).then((mic) => {
              screenStream.addTrack(mic.getTracks()[0]);
              callback(screenStream);
            });
          } else {
            callback(screenStream);
          }
        }).catch(function (error) {
          console.log('error', error);
        });
      } else {
        var error = 'getDisplayMedia API are not supported in this browser.';
        console.log('error', error);
        alert(error);
      }
    },

    //流监听
    addStreamStopListener(stream, callback) {
      stream.addEventListener('ended', function () {
        callback();
        callback = function () { };
      }, false);
      stream.addEventListener('inactive', function () {
        callback();
        callback = function () { };
      }, false);
      stream.getTracks().forEach(function (track) {
        track.addEventListener('ended', function () {
          callback();
          callback = function () { };
        }, false);
        track.addEventListener('inactive', function () {
          callback();
          callback = function () { };
        }, false);
      });
    },
  },
  directives: {
    // 使用局部注册指令的方式
    resize: {
      // 指令的名称
      bind(el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        let width = "",
          height = "";
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value(); // 关键
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      },
    },
  },
  beforeDestroy() {
    window.onresize = null;
    clearInterval(this.timer);
    this.timer = null;
  },
  computed: {
    contentConvent() {
      return function (c) {
        return c
          ? c
            .replaceAll(/\r\n/g, "<br/>")
            .replaceAll(/\n/g, "<br/>")
            .replaceAll(/\s/g, " &nbsp")
          : "";
      };
    },
  },
  created() {
    if (this.screenType == 2) {
      window.opener.postMessage({ allScreen: 4 }, "*");
    } else if (this.screenType == 3) {
      window.opener.postMessage({ allScreen: "5gm" }, "*");
    } else if (this.screenType == 1) {
      window.opener.postMessage({ allScreen: 6 }, "*");
    }
    this.selectEva();
    this.getCourseDetail();
    this.selectCount();
    this.getHomeWork();
    if (this.tType == 4) {
      this.pzDialog = true;
      this.selectPz();
    }
    document.scrollingElement.scrollTop = 0;
    window.addEventListener("resize", () => {
      var a = document.getElementsByClassName("box_course")[0].offsetHeight;
      document.getElementsByClassName("vedioList")[0].style.height = a + "px";
      document.getElementsByClassName("navBox")[0].style.height = a - 40 + "px";
    });
    let _this = this;
    setTimeout(() => {
      _this.vedioTime = [];
      for (var i = 0; i < _this.vedio[_this.taskCount].length; i++) {
        _this.vedioTime[i] = document.getElementsByClassName(
          "vjs-duration-display"
        )[i].textContent;
      }
    }, 1000);
  },
};
</script>

<style scoped>
@media screen and (max-width: 1280px) {

  /* .courseIndex > div:first-child(2) {
    width: 15% !important;
  } */
  /* .navText {
    width: 120px !important;
  } */
  .evaCss {
    flex-direction: column !important;
    align-items: center !important;
  }

  .dialog_diy1>>>.el-dialog {
    width: 100% !important;
  }

  .rightWidthCss {
    width: 100% !important;
  }

  .dialog_diy3>>>.el-dialog {
    width: 100% !important;
  }

  /* .textTitle >>> .el-form-item__label {
    width: 150px !important;
  } */
}

.evaCssMax {
  flex-direction: column !important;
  align-items: center !important;
}

.dialog_diy>>>.el-dialog {
  margin-top: 10vh !important;
}

.body_student {
  width: 77%;
  height: 100%;
  position: absolute;
  left: 22%;
  top: 0;
}

.student_head {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-start;
}

.pb_left {
  width: 20%;
  margin-right: 10px;
  background: rgb(255, 255, 255);
  padding-right: 10px;
  position: fixed;
  height: 100%;
}

.wheel>img,
.project>img,
.star>img,
.evaluate>img,
.up_photo>img,
.chapter_add>img,
.upCover>img,
.deleteWord>img,
.question>img,
.homework>img {
  width: 100%;
  height: 100%;
}

.upCover {
  width: calc(100% / 3.5);
  position: relative;
  margin: 0 15px 10px 0;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.chapter_add {
  width: 120px;
  position: relative;
  text-align: center;
}

.isAddThings {
  margin-top: 20px;
  position: relative;
  text-align: center;
  background: #f7f8fa;
  height: 90px;
  width: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.deleteWord {
  width: 22px;
  height: 22px;
  position: absolute;
  right: -5px;
  top: -5px;
  cursor: pointer;
}

.box_course {
  /* width: 60%; */
  width: 81%;
}

.wheel {
  width: 100%;
  height: 100%;
}

.right_box {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  justify-content: space-around;
}

.right_box_title {
  font-size: 23px;
}

.people {
  display: flex;
}

.student_body {
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  padding: 0 0 20px;
}

.study_top {
  margin-top: 70px;
  width: 100%;
  /* overflow: auto; */
  height: auto;
}

.study_top .checkbox {
  display: flex;
  align-items: center;
  padding: 15px 0 15px 30px;
  flex: 0 0 auto;
  font-weight: bold;
  border-bottom: 1px solid #eee;
}

.study_top .check {
  padding-bottom: 5px;
  text-align: center;
  cursor: pointer;
  height: 30px;
  box-sizing: border-box;
  display: flex;
}

.study_top .checked {
  border-bottom: 4px solid #3fc6a0;
  padding-bottom: 5px;
  color: #3fc6a0;
  display: flex;
  height: 35px;
}

.study_top .checked>div,
.study_top .check>div {
  margin-right: 5px;
}

.videoTop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #fff;
  align-items: center;
  width: 95%;
  padding: 20px;
}

.upbtn {
  margin: 25px;
  background: #70afdb;
  color: #fff;
  width: 120px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  border-radius: 5px;
  cursor: pointer;
}

.filebox {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 15px 0 5px;
}

.filebox .tooldetail {
  width: 100%;
  margin: 0px 12px;
  background: rgb(247, 247, 247);
  padding: 20px;
  line-height: 30px;
  word-break: break-word;
}

.file {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 200px;
}

.file div {
  margin-top: 10px;
  width: 150px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.media {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 20px 20px 0;
  cursor: pointer;
  margin: 12px 0 5px 15px;
  overflow: hidden;
  box-shadow: 0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%),
    0px 2px 1px -1px rgb(0 0 0 / 12%);
  box-sizing: border-box;
}

.media img {
  height: 90px;
  width: 160px;
  object-fit: cover;
}

.media .title {
  padding: 5px;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
}

.media .btn {
  width: 100%;
  height: 35px;
  line-height: 35px;
  color: #fff;
  background: #606060;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.detail_content_top {
  width: 100%;
  padding: 25px 0 25px 0;
}

.detail_title {
  text-align: center;
  font-size: 24px;
}

.detail_time {
  font-size: 13px;
  padding: 15px 0 0 40px;
}

.detail_content {
  line-height: 2pc;
  width: 90%;
  margin: 0 auto;
  padding-top: 30px;
  text-indent: 30px;
  overflow: auto;
  height: 200px;
}

.score_box>>>.el-rate {
  margin-left: 10px;
}

.dialog_change>>>.el-dialog {
  border-radius: 5px;
}

.dialog_change>>>.el-dialog__header {
  background: #f2f2f2;
  text-align: center;
}

.dialog_change>>>.el-dialog__title {
  line-height: 5px;
}

.dialog_change>>>.el-dialog__body {
  background: #fff;
  padding: 10px 20px;
}

.score_box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  margin-top: 20px;
}

.up_photo {
  width: 120px;
  cursor: pointer;
  margin-top: 10px;
}

.upload_send {
  margin: 30px auto 30px;
  width: 60%;
  background: #169bd6;
  text-align: center;
  height: 35px;
  line-height: 35px;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.marginT {
  margin-top: 20px;
}

.cd_content_steps {
  display: flex;
  width: 90%;
  justify-content: space-around;
  border-top: 1px solid #eeeeee;
}

.cd_steps_box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

.first {
  display: flex;
  align-items: center;
  margin: 15px 0 20px 0;
  font-size: 20px;
}

.first>div:nth-child(2) {
  font-size: 16px !important;
  padding-left: 10px;
  line-height: 26px;
  box-sizing: border-box;
}

.blue_box_one {
  text-align: center;
  color: #fff;
  background-image: linear-gradient(90deg, #7960d5, #65b9fc);
  border-radius: 7px;
  margin: 10px;
  cursor: pointer;
  width: 95%;
  height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.blue_box_one>div:nth-child(1) {
  line-height: 30px;
  margin: 0 5px 0 10px;
  width: 30%;
  min-width: 70px;
  border-radius: 4px;
}

.blue_box_one>div:nth-child(2) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  width: 70%;
  text-align: left;
  margin-right: 10px;
  max-width: calc(100% - 85px);
}

.blue_box_one>div:nth-child(2):hover {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.upFile {
  margin: 0 auto;
  width: 120px;
  background: #70afdb;
  color: #fff;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}

.courseTitle {
  background: #634fa4;
  width: 85%;
  margin: 10px auto;
  height: 50px;
  color: #fff;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 10px;
}

.ml {
  margin-left: 20px;
  color: #5b7dba;
  border-left: 3px solid #5b7dba;
  padding-left: 5px;
  font-weight: bold;
}

.return {
  width: 2rem;
  height: 2rem;
  cursor: pointer;
}

.return>img {
  width: 100%;
  height: 100%;
}

.returnBtn {
  background: #7b7cb3;
  width: 65px;
  height: 30px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  margin-right: 20px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
}

.tool {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 13%;
  margin: 0 30px;
  align-items: center;
}

.whiteBIcon {
  width: 150px;
  cursor: pointer;
}

.whiteBIcon>img {
  width: 100%;
  height: 100%;
}

.mask {
  background-color: rgba(0, 0, 0, 0);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressBox {
  width: 500px;
  height: 180px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 6px 1px #bfbfbf;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.progressBox .lbox {
  height: 100px;
  font-size: 19px;
  display: flex;
  align-items: center;
}

.progressBox .lbox img {
  width: 40px;
  margin-right: 20px;
}

.progressBox>>>.el-progress-bar__outer {
  background-color: #d1dfff !important;
}

.progressBox .lbox {
  height: 100px;
  font-size: 19px;
  display: flex;
  align-items: center;
}

.progressBox .lbox img {
  width: 40px;
  margin-right: 20px;
}

.uploadVedio {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  margin: 0 15px 10px 0;
}

.uploadVedio>img {
  width: 30px;
  height: 30px;
}

.uploadVedio>span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75px;
  margin-top: 7px;
}

.picName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75px;
  margin-top: 7px;
}

.new_top {
  display: flex;
  background: #fff;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 60px;
  position: relative;
}

.before {
  position: absolute;
  background: #c3dad4;
  width: 6px;
  height: 100%;
}

.courseIndex {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 520px);
}

.courseIndex>div:nth-child(1) {
  margin: 0 20px;
  padding-left: 5px;
  font-size: 24px;
  min-width: 100px;
  font-weight: bold;
  border-left: 4px solid #5e539d;
  height: 35px;
  text-align: center;
  line-height: 35px;
}

.courseIndex>div:nth-child(2) {
  font-size: 23px;
  /* width: 300px; */
  max-width: calc(100% - 180px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.courseIndex>div:nth-child(3) {
  border-bottom: 1px solid #d7d7d7;
  padding-bottom: 5px;
  background: #967cdf;
  width: 55px;
  min-width: 55px;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  height: 20px;
  line-height: 26px;
  font-size: 14px;
  margin: 0 0 0 10px;
}

.course_text {
  padding: 20px 0 0 15px;
  text-indent: 30px;
  width: 80%;
  min-height: 20px;
}

.vedioList {
  background: #f2f2f2;
  border: 1px solid #ececec;
  /* width: 38.8%; */
  width: calc(100% - 83%);
  height: 445px;
  border-radius: 10px;
  overflow: hidden;
}

.vedioNav {
  margin: 10px 0 0 15px;
  /* border-bottom: 1px solid #d7d7d7; */
  padding-bottom: 5px;
  background: #b9afe3;
  width: 55px;
  min-width: 55px;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  height: 20px;
  line-height: 26px;
  font-size: 14px;
}

.queTop {
  display: flex;
  padding: 20px 0 20px 30px;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  box-sizing: border-box;
}

.question {
  width: 40px;
  margin-right: 10px;
  margin-top: 7px;
}

.queTitle {
  margin-left: 5px;
  font-size: 25px;
  display: flex;
  align-items: center;
}

.addEditor {
  width: 100px;
  height: 30px;
  background: #42cda6;
  color: #fff;
  border-radius: 5px;
  text-align: center;
  line-height: 30px;
  box-shadow: 1px 3px 6px 1px #bfbfbf;
  cursor: pointer;
}

.vedioName {
  /* text-overflow: ellipsis;
  top: 8px;
  font-size: 14px;
  overflow: hidden;
  width: 100%;
  word-break: break-all;
  white-space: nowrap; */

  cursor: pointer;
  margin: 0px 0px 10px 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.vedioTime {
  width: 35px;
  position: absolute;
  color: #fff;
  bottom: 0px;
  right: 0px;
  text-align: center;
  background: #46411f;
  height: 20px;
  font-size: 14px;
  line-height: 20px;
}

.homework {
  width: 200px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
}

.homebox {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
}

.isChooseActive {
  color: #5c549f;
  border-bottom: 2px solid #5c549f;
}

.chooseWho {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  padding-bottom: 10px;
}

.chooseWho>div {
  cursor: pointer;
  padding-bottom: 10px;
  margin: 0 30px;
}

.addPoint>div>img {
  cursor: pointer;
  margin: 0 10px;
  width: 85px;
  border-radius: 15px;
  box-shadow: 0px 1px 8px 0px rgb(20 20 20 / 14%);
}

.addPoint>div {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}

.isBorder>div {
  margin: 0 0 10px 0;
  align-items: flex-start !important;
}

.noiframeBox {
  display: flex;
  flex-wrap: wrap;
}

.iframeBox iframe {
  width: 100%;
  height: 800px;
  border: none;
  margin-bottom: 20px;
  border: 1px solid #ccc;
}

.upload_toolBtn {
  background: #6b92c9;
  color: #fff;
  width: 110px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  bottom: 0;
}

.binfo_input,
.pj {
  font: inherit;
  color: currentColor;
  width: 100%;
  margin: 0;
  padding: 15px 14px;
  display: block;
  min-width: 0;
  outline: none;
  box-sizing: content-box;
  background: none;
  -webkit-tap-highlight-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  box-sizing: border-box;
  resize: none;
}

.binfo_input:focus-visible {
  border: 1px solid rgba(61, 103, 188);
}

.dialog_diy>>>.el-dialog__header,
.dialog_diy1>>>.el-dialog__header {
  background: #454545 !important;
  padding: 15px 20px;
}

.dialog_diy>>>.el-dialog__title,
.dialog_diy1>>>.el-dialog__title {
  color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn,
.dialog_diy1>>>.el-dialog__headerbtn {
  top: 19px;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close,
.dialog_diy1>>>.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close:hover,
.dialog_diy1>>>.el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}

.dialog_diy1>>>.el-dialog__body {
  padding: 0;
}

.dialog_diy>>>.el-dialog__body,
.dialog_diy>>>.el-dialog__footer,
.dialog_diy1>>>.el-dialog__footer {
  background: #fafafa;
}

.a_addBox {
  margin: 10px 0;
  background: #fff;
  padding: 15px;
  max-height: 400px;
  overflow: auto;
}

.a_add_box {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
}

.a_add_head {
  display: flex;
  align-items: flex-start;
  /* justify-content: space-between; */
  flex-direction: column;
  margin: 10px 0;
  font-size: 18px;
  width: 100%;
}

.a_add_head .a_add_head_input {
  width: 300px;
}

.a_add_head .a_add_head_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.a_add_body {
  display: flex;
  align-items: center;
}

.a_add_input {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.a_add_input>>>el-radio-group {
  margin: 10px 0;
}

.a_add_input>>>.el-radio {
  margin-bottom: 10px;
}

.redioStyle>>>.el-radio__label {
  font-size: 18px;
}

.redioStyle>>>.el-checkbox__label {
  font-size: 18px;
}

.toolHeng2 {
  width: 100%;
}

.toolHeng {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.toolHeng>div {
  padding-left: 20px;
}

.isWidth {
  width: 20%;
}

.textTitle {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 95%;
}

.textTitle>>>.el-form-item__label {
  font-size: 22px;
  color: #918f8f;
  width: 100px;
}

.textTitle>>>.el-form-item__content {
  width: calc(100% - 100px);
}

.textCss>>>.el-dialog {
  width: 800px !important;
  height: 400px;
  background: #fafafa;
}

.textCss>>>.el-dialog__body {
  margin: 55px 8% 0 8%;
  padding: 0 !important;
}

.textCss>>>.el-dialog__footer {
  padding-top: 38px;
}

.toolsCss>>>.el-dialog__body {
  padding: 20px;
}

.lineCss>>>.el-dialog__body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.newNav {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-start;
}

.navText {
  cursor: pointer;
  margin: 0px 0px 10px 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 300px; */
  width: 100%;
}

.noVedio {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
}

.noNavText {
  cursor: pointer;
  margin: 0px 0px 10px 5px;
  width: 112px;
}

.listNoVedio {
  margin: 0 0 0 30px;
  width: 97%;
}

.video-player>>>.video-js {
  height: 100%;
}

.hangVedioList {
  width: 90% !important;
  height: 150px !important;
  margin: 20px 0 0 30px;
}

.hangVedio {
  width: 100%;
  height: 170px !important;
  align-items: flex-start !important;
}

.hangHand {
  height: 150px !important;
}

.twoChild {
  width: 95%;
  margin: 10px;
  border-radius: 5px;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  transition: all 0.5s;
  overflow: hidden;
  height: 0;
  background: #e7f3ff;
}

.twoChild>div:nth-child(1) {
  margin-top: 5px;
}

.navChild {
  width: 100%;
  cursor: pointer;
  margin-bottom: 10px;
  position: relative;
}

.navChild img {
  position: absolute;
  right: 11px;
  width: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.navActive {
  height: auto;
}

.navTask {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: flex-start;
  height: 40px;
  justify-content: flex-start;
  padding: 0 10px;
  width: 100%;
  box-sizing: border-box;
}

.navTaskname {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  padding-left: 5px;
}

.openTaskActive {
  color: #947edc;
}

.iframeName {
  margin: 5px 0;
  border-left: 4px solid #41c4a4;
  padding-left: 4px;
}

.toolTitle {
  margin: 0px 0px 20px;
  font-size: 20px;
  font-weight: 500;
  border-left: 4px solid #41c4a4;
  padding-left: 4px;
}

.cru_selectBox {
  overflow: auto;
  width: 96%;
  margin: 0 auto;
  height: calc(100% - 40px - 21px - 20px);
}

.cru_selectBox::-webkit-scrollbar,
.study_top::-webkit-scrollbar,
.textContent::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
.cru_selectBox::-webkit-scrollbar-track,
.study_top::-webkit-scrollbar-track,
.textContent::-webkit-scrollbar {
  border-radius: 10px;
  background-color: #b8bdc9;
}

/*定义滑块 内阴影+圆角*/
.cru_selectBox::-webkit-scrollbar-thumb,
.study_top::-webkit-scrollbar-thumb,
.textContent::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgb(96, 125, 184);
  background-color: #2c5ab3;
}

.vedioBox {
  border-radius: 20px;
  background: #fff;
  margin-bottom: 10px;
}

.taskBox {
  margin: 15px auto 20px;
  background: #f7f7f7;
  width: 97%;
  border-radius: 10px;
}

.vedioTaskBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.toolBox {
  padding: 20px 0 0 0;
  display: flex;
}

.btnAll {
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.vedioTimeBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
}

.navBox {
  background: rgb(255, 255, 255);
  height: 400px;
  padding: 5px 1px 0 1px;
  overflow: auto;
}

.worksBox {
  padding: 5px 0 0 10px;
  border-bottom: 1px solid #eeeeee;
}

.worksBTitle {
  font-size: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
}

.greenBox {
  width: 5px;
  height: 30px;
  background: #63b6fa;
  margin-right: 5px;
}

.worksDetailBox {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  padding: 15px 0;
}

.works {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: center;
  max-width: 240px;
  width: calc(100% / 3 - 10px);
  height: auto;
  margin-right: 10px;
  margin-bottom: 10px;
  overflow: hidden;
  height: 140px;
  box-shadow: 0 0 6px 1px #dfdada;
  border-radius: 15px;
}

.workImg {
  width: 100%;
  /* height: calc(100% - 40px); */
  height: 105px;
  position: relative;
}

.workImg>img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.worksName {
  height: 40px;
  line-height: 40px;
  display: flex;
  width: 92%;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin: 0 10px;
}

.worksName>div:nth-child(1) {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.worksName>div:nth-child(2) {
  color: #b7b4b5;
}

.noWorksS {
  padding: 15px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.noWorksName,
.isWorksName {
  background: #967cdf;
  color: #fff;
  width: 90px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 5px;
  margin: 10px 15px 10px 0;
  white-space: nowrap;
  overflow: hidden;
  padding: 5px;
  text-overflow: ellipsis;
}

.isWorksName {
  cursor: pointer;
  background: #967cdf !important;
  width: 100px;
  height: 40px;
  line-height: 40px;
  position: relative;
}

.noWorksName:hover {
  background: #8363dc !important;
}

.title {
  background: #74679c;
  /* width: 98%; */
  height: 45px;
  color: #fff;
  line-height: 45px;
  padding-left: 20px;
  box-sizing: border-box;
}

.textBox {
  font-size: 20px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px auto 0;
}

.textContent {
  font-size: 18px;
  height: 450px;
  width: 95%;
  overflow: auto;
  line-height: 30px;
}

.answerBg {
  background: url("../../assets/icon/answerBgNew.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  position: relative;
  justify-content: center;
}

.answerBg>div:nth-child(1) {
  /* font-size: 22px;
  padding: 25px 0 10px; */
}

.answerContent {
  width: 215px;
  max-height: 60px;
  word-break: break-all;
  text-align: center;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  /* padding: 23px 0 0; */
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  font-size: 15px;
}

.elist_input_box {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  padding: 10px 0 15px 30px;
  flex-direction: column;
}

.elist_input {
  /* width: 40%; */
  width: 100%;
}

.elist_input .elist_input_box input {
  font: inherit;
  color: currentColor;
  width: 200px;
  padding: 8px 14px;
  display: block;
  min-width: 0;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  box-sizing: border-box;
  background: #fff;
  margin: 0 20px 0 0;
}

.elist_input .elist_input_box span {
  height: 36px;
  line-height: 36px;
  color: rgb(82, 82, 82);
}

.elist_input .elist_input_box .remove {
  height: 20px;
  width: 20px;
  background-size: 100% 100%;
  background-position: unset;
  margin-left: 5px;
}

.elist_input_box>>>.el-rate {
  display: flex;
  height: 36px;
  align-items: center;
}

.elist_input_box .elist_inptu_text {
  min-height: 50px;
  /* width: 500px;
  max-height: 150px; */
  width: 100%;
  line-height: 50px;
  color: rgb(82, 82, 82);
  overflow: auto;
  text-indent: 5px;
  background: #f7f6f9;
  border-radius: 10px;
}

.elist_input_box .elist_inptu_text input {
  width: 500px;
}

.elist_input_box>>>.el-rate__icon {
  font-size: 24px;
}

.isClick {
  background: #947edc;
}

.bzBox {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bzBox>div:nth-child(1) {
  width: 4px;
  height: 40px;
  background-image: linear-gradient(180deg, #2c5cbd, #a1cff4);
}

.bzBox>div:nth-child(2) {
  font-size: 23px;
  font-weight: bold;
  padding: 0px 0px 0 10px;
}

.navTitile {
  padding: 0 0px 0 15px;
  background: #74679c;
  color: #fff;
  height: 40px;
  line-height: 40px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.isTypeOne {
  width: 240px;
  height: 170px;
  /* border: 1px solid #f8f8f8; */
  border-radius: 10px;
  box-shadow: 0 0 6px 1px #dfdada;
}

.e_add_top {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0 20px;
  border-radius: 3px;
  background: #fff;
}

.e_add_title2 {
  display: flex;
  align-items: center;
}

.e_add_title2 span {
  width: 40px;
}

.e_add_title {
  display: flex;
  align-items: center;
  color: #b8b8b8;
  font-size: 18px;
  position: relative;
  height: 40px;
}

.e_add_title span {
  margin-right: 10px;
}

.e_add_title .el_input {
  width: 300px;
}

.e_add_title>>>.el-input__inner {
  width: 400px;
}

.e_add_btn {}

.e_add_content {
  display: flex;
  width: 100%;
  max-width: 650px;
  height: 550px;
}

.e_add_list {
  background: #fff;
  height: 500px;
  width: 210px;
  position: relative;
  margin: 15px 5px 0 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.e_add_list_title {
  font-size: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 40px;
  text-align: center;
  border-bottom: 1px solid #eaeaea;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 57px;
  background: #f6f6f6;
}

.e_add_list_title span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.e_add_list_title img {
  position: absolute;
  right: 15px;
  width: 25px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
}

.e_add_list_body {
  height: calc(100% - 187px);
  overflow: auto;
}

.e_add_list_child {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  padding: 15px 40px;
  text-align: center;
}

.e_add_list_child span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.e_add_list_child img {
  position: absolute;
  right: 10px;
  width: 21px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
}

.e_add_list_child+.e_add_list_child {
  border-top: 1px solid #eaeaea;
}

.e_add_list_child .active {
  color: #409eff;
}

.e_add_list_btn {
  position: absolute;
  bottom: 0;
  height: 50px;
  background: rgb(120, 120, 254);
  width: 100%;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
}

.e_add_list_detail {
  position: absolute;
  bottom: 0;
  height: 130px;
  background: rgb(120, 120, 254);
  width: 100%;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.e_add_list_detail textarea {
  height: 90%;
  width: 95%;
  border: none;
  resize: none;
  outline: none;
  padding: 5px;
  box-sizing: border-box;
}

.e_add_list_pbox {
  width: 100%;
  max-width: 650px;
  /* height: 600px; */
}

.e_add_list_pbox_title {
  height: 50px;
  background: #fff;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
}

.type_title {
  font-size: 18px;
  font-weight: 700;
}

.type_content {
  font-size: 16px;
  margin-left: 30px;
}

.type_content span+span {
  margin-left: 20px;
}

.type_content span {
  cursor: pointer;
  padding-bottom: 5px;
  box-sizing: border-box;
}

.type_content .active {
  color: #5c549f;
  border-bottom: 2px solid #5c549f;
}

.e_add_list_pbox_content {
  height: calc(100% - 50px);
  display: flex;
  align-items: center;
  width: 100%;
  background: #fff;
}

.evaCss {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.cru_line {
  position: absolute;
  bottom: 0px;
  transition: all 0.5s;
  left: 0px;
  width: 125px;
  margin-left: -25px;
}

.isNoMessage {
  width: 20%;
  margin: 25% auto 0;
}

.isNoMessage>img {
  width: 100%;
  height: 100%;
}

.fullStyle>>>.el-dialog__body {
  height: 100% !important;
}

.fullStyle>>>.el-dialog,
.fullStyle {
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.full_diy>>>.el-dialog {
  margin: 0 !important;
  height: 100%;
  padding: 4px;
}

.full_diy>>>.el-dialog__body {
  height: calc(100% - 100px);
}

.full_diy2>>>.el-dialog__body {
  height: calc(100% - 50px);
  padding: 0;
}

.switchCss {
  /* width: 100%; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  /* justify-content: center; */
}

.isClickNav {
  color: #947edc;
}

.commentImg {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.commentImg>img {
  width: 100%;
  height: 100%;
}

.comment {
  background: #f9f9f9;
  border-radius: 0 0 15px 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  height: 35px;
}

.commentList {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  /* margin-left: 15px; */
  margin-left: 8px;
}

.scoreImg {
  width: 17px;
  height: 17px;
}

.studentDetail {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  /* align-items: center; */
  align-items: flex-start;
}

.tx {
  width: 50px;
}

.tx>img {
  width: 100%;
  height: 100%;
}

.nameAndTime {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  margin-left: 10px;
}

.worksAnswer {
  color: #4078dd;
  margin: 10px 0;
  font-size: 16px;
}

.worksAnswer>img {
  width: 500px;
  height: 300px;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}

.commentTop {
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 10px;
}

.commentBox {
  padding-top: 15px;
}

.pl {
  font-size: 18px;
}

.plName {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: baseline;
  color: #78787a;
}

.evalCss {
  background: #fff;
  font-size: 18px;
}

.nav {
  color: #9d9d9d;
  padding: 5px 0 15px 20px;
}

.middleBox {
  padding: 5px 0 15px 20px;
}

.pfBox {
  padding-bottom: 30px;
}

.nameAndrate {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding-bottom: 10px;
}

.nameAndrate>div {
  margin-left: 10px;
  color: #000;
}

.pfBox>div:nth-child(2) {
  background: #f7f6f9;
  width: 400px;
  min-height: 45px;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 20px;
  box-sizing: border-box;
  color: #000;
}

.bz {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.bz>div {
  padding: 0 10px;
}

.select_box2_title {
  background: #fff;
  border-radius: 5px;
  padding: 15px 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.select_box2_title>div:nth-child(2) {
  margin-left: 10px;
  color: #c4c4c4;
}

.select_box2_box {
  display: flex;
  height: 500px;
}

.select_box2_img {
  width: calc(100% - 310px);
  height: 100%;
  overflow: auto;
  background: #fff;
  border-radius: 5px;
}

.select_box2_img img {
  width: 100%;
}

.select_box2_answer {
  background: #fff;
  margin-left: 10px;
  border-radius: 5px;
  width: 300px;
  overflow: auto;
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 10px;
  box-sizing: border-box;
  position: relative;
}

.select_answer_title {
  padding: 0 0 15px 20px;
  color: #c4c4c4;
}

.select_box2_answer_box {
  margin: 0 0 10px 20px;
  width: 85%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.select_box2_answer_box>>>.el-input.is-disabled .el-input__inner {
  color: #000;
}

.upAnswerCss {
  position: absolute;
  bottom: 15px;
  right: 15px;
}

.upAnswerCss>>>.el-button {
  width: 95px;
  height: 35px;
  line-height: 35px;
  padding: 0;
}

.rightWidthCss {
  width: 60%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.rightAnswer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  color: red;
  margin-bottom: 31px;
}

.rightAnswerCss {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-top: 60px;
}

.blueCss {
  color: #767de1;
  margin-left: 10px;
}

.redCss {
  color: red;
}

.redioStyle>>>.el-radio__input.is-checked+.el-radio__label {
  color: rgb(0 123 255) !important;
}

.redioStyle>>>.el-checkbox__input.is-checked+.el-checkbox__label {
  color: rgb(0 123 255) !important;
}

.zuoyeYulan {
  padding-top: 15px;
  font-size: 18px;
  display: flex;
  align-items: flex-end;
}

.buttonA {
  margin-left: 10px;
  padding: 0;
  color: #8681b7;
}

.displayBox {
  margin-bottom: 10px;
  display: block;
  border-bottom: 3px solid #eee;
  display: flex;
  align-items: center;
}

.easy_comment {
  width: calc(100% - 90px);
  margin-left: 10px;
  display: flex;
  flex-wrap: wrap;
}

.easy_comment>div {
  border: 1px solid #4a4a4a;
  color: #666;
  border-radius: 15px;
  padding: 5px 10px;
  font-size: 16px;
  margin-bottom: 10px;
  margin-right: 5px;
  cursor: pointer;
}

.easy_comment div:hover {
  border: 1px solid #f7ba2a;
  color: #c69217;
}

.xuan_right_box {
  padding: 10px;
  background: rgb(247, 247, 247);
  margin: 10px 12px;
  border-radius: 5px;
}

.tool_right_box {
  display: flex;
  align-items: center;
}

.tool_right_box+.tool_right_box {
  margin-top: 10px;
}

.right_box_xuan {
  background: rgb(0 123 255);
  color: #fff;
  border-radius: 5px;
  padding: 5px;
  margin-left: 10px;
}

.pButton {
  position: fixed;
  /* right: 5%; */
  /* bottom: 5%; */
  color: #fff;
  /* width: 50px;
  height: 50px; */
  /* border-radius: 50%; */
  text-align: center;
  /* line-height: 50px; */
  /* background-image: -webkit-linear-gradient(left, #72aaf4, #4d81d5); */
  cursor: pointer;
  z-index: 999;
  right: 0;
  top: 83px;
  width: 50px;
  height: 50px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0 8px 0px #c5c5c5;
}

.pzClass {
  width: calc(100% - 340px);
}

.newDialogCss {
  /* position: fixed;
  right: 5%;
  top: 50%;
  width: 340px;
  transform: translateY(-50%);
  height: 60%;
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 15px;
  z-index: 999; */
  position: fixed;
  right: 0;
  top: 70px;
  width: 340px;
  height: calc(100% - 80px);
  z-index: 999;
  background: #fff;
  border-radius: 15px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  overflow: hidden;
}

.pzTop {
  color: #fff;
  background: #000;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  border-radius: 15px 15px 0 0;
}

.pzTop2 .checkbox {
  display: flex;
  align-items: center;
  padding: 15px 30px;
  flex: 0 0 auto;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  justify-content: space-between;
}

.pzTop2 .check {
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
}

.pzTop2 img {
  width: 25px;
  cursor: pointer;
}

.pzTop>div:nth-child(1) {
  padding-left: 10px;
}

.pzTop>div:nth-child(2) {
  width: 15px;
  height: 15px;
  padding-right: 10px;
  cursor: pointer;
}

.pzTop>div:nth-child(2)>img {
  width: 100%;
  height: 100%;
}

.pzBox,
.noPzBox {
  height: calc(100% - 60px);
  /* background: #ededed; */
  background: #fff;
  /* border-radius: 0 0 15px 15px; */
}

.noPzBox {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.pzList {
  background: #f7f7f7;
  width: 90%;
  margin: 0 auto 15px;
  border-radius: 5px;
}

.pzNavTop {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 10px 10px 0 10px;
  align-items: center;
}

.pzDelete {
  cursor: pointer;
  margin-left: auto;
  font-size: 14px;
  color: #afafaf;
}

.pzNavTop>div:nth-child(1) {
  background: #967cdf;
  width: 35px;
  height: 35px;
  color: #fff;
  text-align: center;
  line-height: 35px;
  border-radius: 50%;
  font-size: 14px;
}

.pzNavTop>div:nth-child(2) {
  font-size: 18px;
  color: #959595;
  margin-left: 5px;
}

.pzContent {
  padding: 10px;
  word-break: break-word;
}

.pzContent audio {
  width: 100%;
}

.pzContent audio::-webkit-media-controls-panel {
  background: #fff;
}

.pzListBox {
  padding-top: 15px;
  height: calc(100% - 60px);
  overflow: auto;
}

.addPzButton {
  position: relative;
  margin-top: 3px;
  width: 100%;
}

.addPzButton .img1 {
  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);
  height: 100%;
  display: flex;
  align-items: center;
}

.addPzButton .img1 div {
  display: flex;
}

.addPzButton .img1 div img {
  width: 28px;
  margin-left: 10px;
  cursor: pointer;
}

.addPzButton .img1 div span {
  font-size: 14px;
  margin: 4px 0 0 3px;
  color: #afafaf;
}

.addPz {
  background: #8681b7;
  width: 100px;
  color: #fff;
  font-size: 12px;
  height: 30px;
  margin: 0 auto;
  text-align: center;
  line-height: 30px;
  border-radius: 10px;
  cursor: pointer;
}

.addDialogCss {
  position: fixed;
  right: 37%;
  top: 50%;
  width: 600px;
  transform: translateY(-50%);
  height: 70%;
  min-height: 450px;
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 15px;
  z-index: 999;
}

.teacherPz {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}

.teacherPzImg {
  width: 30px;
  height: 30px;
}

.teacherPzImg>img {
  width: 100%;
  height: 100%;
}

.addPzBox {
  height: calc(100% - 40px);
  background: #ededed;
}

.pzAudioClass {
  margin: 15px 14px;
  background: #fff;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pzConText {
  width: 95%;
  height: 100%;
  margin: 10px auto 0;
  border: none;
  background: #fff;
  border-radius: 0px;
}

.pzConText>>>.text {
  height: calc(100% - 82px);
}

.addTextCss {
  background: #8681b7;
  width: 80px;
  height: 30px;
  text-align: center;
  color: #fff;
  line-height: 30px;
  border-radius: 10px;
  margin: 10px auto 0;
  cursor: pointer;
}

.pzConText:focus-visible {
  border: none !important;
}

.maxWidth {
  width: 1000px;
}

.noPz {
  width: 150px;
  margin: 0 auto 20%;
}

.noPz>img {
  width: 100%;
  height: 100%;
}

.pzList .time {
  text-align: right;
  box-sizing: border-box;
  padding: 0 10px 10px 0px;
  color: #949494;
  font-size: 14px;
}

/* table 样式 */
.cont>>>table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.cont>>>table td,
.cont>>>table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
  max-width: 0px;
}

.cont>>>table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}

/* blockquote 样式 */
.cont>>>blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

.addPzCheck {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 10px 15px 0;
}

.addPzCheck span {
  cursor: pointer;
  padding-bottom: 5px;
  font-weight: bold;
}

.addPzCheck span+span {
  margin-left: 10px;
}

.addPzCheck .isChooseActive {
  color: #5c549f;
  border-bottom: 2px solid #5c549f;
}

/* code 样式 */
.cont>>>code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}

.cont>>>pre code {
  display: block;
}

/* ul ol 样式 */
.cont>>>ul,
ol {
  margin: 10px 0 10px 20px;
}

.scoreBox,
.scoreDetailBox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  font-size: 18px;
  width: 100%;
}

.scoreBox .t,
.scoreDetailBox .t {
  margin-right: 10px;
  width: 100px;
  text-align: right;
}

.scoreDetailBox {
  align-items: flex-start;
}

.scoreDetailBox>>>.el-textarea {
  width: calc(100% - 200px);
}

.scoreBox>>>.el-input {
  width: 130px;
  font-size: 38px;
}

.scoreBox>>>.el-input__inner {
  height: 60px;
}

.answerScore {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #0000008f;
  border-radius: 5px;
  padding: 3px 5px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}

.open_box .switch_box {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.open_box .switch_box+.switch_box {
  margin-top: 10px;
}

.deleteImg {
  width: 25px !important;
  height: 25px !important;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.deleteImg2 {
  width: 15px !important;
  height: 15px !important;
  top: 5px;
  right: 5px;
}

.rightW {
  right: 40px;
}

.drawPBox {
  display: flex;
  flex-direction: column;
  position: relative;
}

.drawPBox span {
  font-size: 18px;
  color: #606266;
  padding-bottom: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #eaeaea;
}

.drawPBox img {
  width: 500px;
  height: 300px;
  object-fit: contain;
  cursor: pointer;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/GM/studyStudentGM.vue